import * as React from 'react';
import { SvgIcon, createTheme as createTheme$1, ThemeProvider as ThemeProvider$1, CssBaseline, StyledEngineProvider } from '@mui/material';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */
var SplitHorizontal = function SplitHorizontal(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 2v20H2V2h20zM8 3.999 4 4v16l4-.001v-16zM20 4l-10-.001v16L20 20V4zm-5 4c.3 0 .545.244.545.545v2.91h2.91a.544.544 0 1 1 0 1.09h-2.91v2.91a.545.545 0 1 1-1.09 0v-2.91h-2.91a.544.544 0 1 1 0-1.09h2.91v-2.91c0-.301.244-.545.545-.545z"
  }));
};
var SplitVertical = function SplitVertical(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 22H2V2h20v20zM20.001 8 20 4H4l.001 4h16zM20 20l.001-10h-16L4 20h16zm-4-5c0 .3-.244.545-.545.545h-2.91v2.91a.544.544 0 1 1-1.09 0v-2.91h-2.91a.545.545 0 1 1 0-1.09h2.91v-2.91a.544.544 0 1 1 1.09 0v2.91h2.91c.301 0 .545.244.545.545z"
  }));
};
var Expand = function Expand(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.36 9.5c.752.001 1.36.607 1.36 1.355v5.436h5.42c.751 0 1.36.607 1.36 1.355A1.357 1.357 0 0 1 13.14 19H5v-8.145A1.36 1.36 0 0 1 6.36 9.5zM19 4v8.145c0 .749-.609 1.354-1.36 1.355a1.359 1.359 0 0 1-1.36-1.355V6.709h-5.42c-.75 0-1.36-.607-1.36-1.355 0-.374.152-.713.398-.958.248-.245.587-.396.963-.396H19z"
  }));
};
var UnExpand = function UnExpand(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.86084312,12 C3.48526636,12 3.14555369,12.1508094 2.89848993,12.3958747 C2.6524224,12.6409399 2.5,12.9802611 2.5,13.3543081 C2.5,14.1024021 3.1096896,14.7086162 3.86084312,14.7086162 L9.27930998,14.7086162 L9.27930998,20.1446997 C9.27930998,20.8937859 9.88899958,21.4990078 10.6401531,21.5 C11.3913066,21.4990078 12,20.8937859 12,20.1446997 L12,12 L3.86084312,12 Z M21.1401531,8.29138381 L15.72069,8.29138381 L15.72069,2.85530026 C15.72069,2.10720627 15.1119966,1.50099217 14.3608431,1.5 C13.6086934,1.50099217 13.0009962,2.10819843 13,2.85530026 L13,11 L21.1401531,11 C21.5157299,11 21.8554425,10.8491906 22.1015101,10.6041253 C22.3475776,10.3590601 22.5,10.0197389 22.5,9.64569191 C22.5,8.89759791 21.8913066,8.29138381 21.1401531,8.29138381"
  }));
};
var Delete = function Delete(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.504 8.228c.588 0 1.027.48.973 1.066l-.876 9.64A1.197 1.197 0 0 1 16.434 20H8.41c-.59 0-1.115-.48-1.167-1.066l-.877-9.64a.962.962 0 0 1 .973-1.066zm-2.115 1.228a.82.82 0 0 0-.819.82v7.674a.818.818 0 0 0 1.638 0v-7.675a.819.819 0 0 0-.819-.819zm-2.968 0a.819.819 0 0 0-.819.82v7.674a.818.818 0 1 0 1.638 0v-7.675a.82.82 0 0 0-.82-.819zm-2.968 0a.819.819 0 0 0-.818.82v7.674a.818.818 0 1 0 1.637 0v-7.675a.82.82 0 0 0-.82-.819zM13.432 4c.21 0 .404.168.436.376l.107.758 3.256-.01a1.606 1.606 0 0 1 1.61 1.6l.001.535-12.841.038L6 6.76a1.605 1.605 0 0 1 1.6-1.61l3.262-.008.103-.758a.454.454 0 0 1 .434-.38z"
  }));
};
var DrawRegion = function DrawRegion(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M6,2 L6,2.999 L10,2.999 L10,2 L14,2 L14,2.999 L18,2.999 L18,2 L22,2 L22,6 L20.999,6 L20.999,10 L22,10 L22,14 L20.999,14 L20.999,18 L22,18 L22,22 L18,22 L18,20.999 L14,20.999 L14,22 L10,22 L10,20.999 L6,20.999 L6,22 L2,22 L2,18 L2.999,18 L2.999,14 L2,14 L2,10 L2.999,10 L2.999,6 L2,6 L2,2 L6,2 Z M10,4.999 L6,4.999 L6,6 L4.999,6 L4.999,10 L6,10 L6,14 L4.999,14 L4.999,18 L6,18 L6,18.999 L10,18.999 L10,18 L14,18 L14,18.999 L18,18.999 L18,18 L18.999,18 L18.999,14 L18,14 L18,10 L18.999,10 L18.999,6 L18,6 L18,4.999 L14,4.999 L14,6 L10,6 L10,4.999 Z"
  }));
};
var DrawPolygon = function DrawPolygon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M14,1 L14,4.113 L12.0044614,2.2 L11.994,5.221 L4.039,19 L5,19 L5,23 L1,23 L1,19 L2.307,19 L10.389,5 L10,5 L10,1 L14,1 Z M13.0044614,4.62000715 L23.2887637,14.4827842 L18.3738381,14.8752125 L20.4451897,19.755011 L18.7229079,20.4860763 L16.6515563,15.6062777 L12.9550728,18.8691758 L13.0044614,4.62000715 Z"
  }));
};
var DrawFIRLand = function DrawFIRLand(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "m8.792 0 4.37 2.748h5.106v7.48l.043.078a.585.585 0 0 1 .178-.048.691.691 0 0 1 .344.062l.105.06v.16l.033.04.048.255c.163.103.286.169.37.197a.295.295 0 0 0 .218 0c-.013.124-.013.192 0 .204.04.037.162.08.37.13a.874.874 0 0 1 .025.237.202.202 0 0 1-.07.124.25.25 0 0 0-.032.187c.007.03.058.003.076.106.007.04-.005.114 0 .225.002.047.01.13.026.251a1.363 1.363 0 0 1-.102.373c-.04.078-.138.203-.293.375a.19.19 0 0 1 0 .113c-.017.049-.063.047-.064.069-.01.155.003.436-.033.794-.004.046-.026.107-.07.117-.045.011-.103-.056-.157-.06-.08-.007-.148.036-.214.027-.019-.002-.056-.06-.077-.063-.05-.007-.144.04-.258.035a.293.293 0 0 1-.094-.025l-.066-.03-.085.116-.014.202c.086.035.128.063.127.083 0 .01-.025.02-.072.034l-.055.015-.013.047-.07.024c.024.002.04.029.048.08a.528.528 0 0 1-.02.205c.075.064.136.1.182.11.045.009.116 0 .211-.029.071.091.156.137.256.137.15 0 .131-.174.214-.137.04.018.052.128.125.24.012.02.036.043.072.068l.063.04v.221a.442.442 0 0 0-.115.262c-.007.135.097.198.06.301-.036.104-.129.01-.187.062-.04.034-.075.106-.107.217a.51.51 0 0 0-.202.098c-.052.052-.013.15-.09.194-.077.044-.243-.003-.3.03-.075.043-.032.161-.081.185-.032.015-.107.016-.13.033-.025.021-.034.062-.024.122a.785.785 0 0 1 .235.08c.078.046.193.11.211.222.01.058-.049.096-.08.13-.027.032-.024.06-.057.098a.864.864 0 0 1-.214.176c-.045.027-.09-.106-.152-.079-.103.048-.339.152-.63.31-.016.009-.063-.006-.143-.042l-.066-.032v.176h-.14c-.011-.044-.027-.071-.047-.08a.152.152 0 0 0-.068-.007l-.055.007-.073-.131-.235.035c-.089-.144-.142-.203-.16-.179-.01.014-.126-.045-.114.022.005.028.044.079.117.152l.06.06-.027.091-.32-.122-.183.152h-.139l-.02.07.102.151v.102l-.102.065.02.05.082-.02.164.12v.21l.246.089-.077.223.077.067.035.11.079.056.064.121.096.113.02.15.023.071-.023.08.016.091-.036.12.068.054-.032.03.007.129-.082.105-.035.043-.05.02a3.573 3.573 0 0 1-.15.273l-.06.084-.065.076v.05l-.02.052c.001.131.024.205.068.22.066.023.165-.131.227-.118.032.006-.04.048-.057.118-.003.014.016.037.057.069a.682.682 0 0 0-.275.18c-.063.06-.18.125-.26.215a.133.133 0 0 0-.024.042l-.03.098a.117.117 0 0 1-.073.072c-.102.036-.125-.132-.158-.13-.088.006-.093.15-.097.166-.004.02.02.046.054.074.008.006.01.018.01.033l-.009.1.011.03c.035.022.151-.055.155-.05.053.056.22-.022.274.05.025.033-.113.08-.051.204.062.124.15.03.198.1.017.024-.022.04-.02.092 0 .021.014.066.042.133-.013.054-.027.086-.042.094-.02.011-.052-.02-.073-.019a.109.109 0 0 0-.085.046c-.02.025.018.118 0 .164-.014.035-.105.022-.107.063-.002.05.164.085.087.184-.077.099-.123-.016-.169-.016-.046 0-.114.06-.186.053-.02-.002-.008-.063-.035-.072-.021-.007-.08.038-.105.035-.018-.002-.021-.038-.04-.035-.022.003-.06.045-.085.042-.029-.004-.085-.114-.129-.114-.034.001-.052.114-.09.107-.09-.016-.132.056-.162.007-.015-.025.014-.077.02-.127.002-.027-.022-.055-.02-.077.003-.018.024-.024.02-.036-.03-.07-.122-.027-.17-.115-.031-.058-.042-.108-.032-.15.02-.05.04-.084.059-.105.027-.03.077-.001.106-.025.033-.028.044-.108.054-.13.023-.045.06.053.063 0 0-.02.092-.136.085-.192-.007-.06-.022.06-.085 0-.017-.016-.019-.047-.012-.085.008-.042.104-.059.125-.108.016-.037.059-.115.054-.155-.005-.038-.058-.038-.052-.052l.052-.127c.005-.014.064.026.07.013.019-.047-.017-.145 0-.187.007-.018.125.02.128 0 .005-.022-.105-.101-.094-.138.01-.027.108-.062.122-.1.006-.016-.013-.04-.057-.074-.074.03-.126.037-.156.022-.045-.023.021-.117-.065-.14-.086-.02-.178.024-.257.024-.053 0-.089-.03-.107-.09-.054-.035-.14-.049-.2-.065-.024-.006-.035-.007-.05-.018l-.025-.024v-.215l-.165-.148a.814.814 0 0 1-.12.09c-.02.012-.06.004-.098.022a.391.391 0 0 0-.082.064.44.44 0 0 0-.144-.028.157.157 0 0 0-.093.044 1.378 1.378 0 0 0-.182-.029c-.053-.002-.095.04-.128.013-.097-.078.06-.191 0-.24-.06-.05-.177 0-.245-.03-.069-.03-.025-.05-.08-.14-.053-.092-.16-.137-.16-.241 0-.07.032-.132.094-.188a.558.558 0 0 0-.079-.157c-.012-.014-.042-.024-.091-.029.002-.04-.006-.06-.023-.06-.027 0-.036.015-.056.06-.02.046.004.083-.033.136-.02.03-.07.081-.153.157l-.068.06-.171-.08a.953.953 0 0 1-.24.046c-.053 0-.087-.015-.102-.046-.01-.053-.004-.083.018-.089.022-.006.071.007.15.04a1.621 1.621 0 0 1 0-.143c.002-.043.043-.06.037-.095-.006-.04-.061-.097-.102-.112-.153-.058-.298.059-.434.35-.04.016-.066.022-.078.02-.08-.018-.125-.044-.167-.044a.488.488 0 0 0-.14.024c-.115-.062.035-.218 0-.252-.018-.016-.056-.018-.114-.004l-.065.018-.27.123.03.075-.03.09.117.19c.01.048-.004.078-.042.09a.492.492 0 0 1-.155.007l-.083-.007-.061-.09h-.21c.002-.004-.027.018-.037 0-.015-.028-.016-.1-.026-.11-.029-.03-.075-.032-.074-.035.005-.013-.023-.028-.068-.017-.014.004-.022.03-.04.034a.704.704 0 0 1-.065.011l-.05.006-.287-.11c-.007-.03-.015-.048-.026-.057l-.02-.006-.03.006-.13-.118-.053.013c-.009-.013-.023-.017-.042-.013a.19.19 0 0 0-.047.021l-.032.02v.053l-.09.212-.06-.02-.059.05h-.156a.29.29 0 0 0-.113-.117c-.067-.036-.139-.006-.14-.017a.184.184 0 0 0-.052-.108.24.24 0 0 0-.085-.064l.014-.013.02-.017v-.039l-.088.04-.083.093a.37.37 0 0 0-.105-.026c-.062.001-.098.028-.1.026-.059-.049-.108-.082-.148-.133-.032-.04-.056-.1-.095-.138-.06-.06-.173-.108-.189-.167-.02-.074.018-.09.114-.15.074-.046.182-.14.317-.187.014-.005.046-.002.097.01l.058.014.05.122.121.1a.215.215 0 0 0 .051.125c.04.042.073.03.104 0a.188.188 0 0 0 .024-.054l.018-.057.21.015.033-.028h.068l.055.028h.118l.091-.015.056.077.083-.029.133.084.108.067.049.076c-.006.023-.006.04 0 .05.022.04.071.075.092.096.03.03.084.07.163.116.009-.032.049-.057.121-.075.054-.014.13-.025.227-.033l.104-.008-.024-.164-.2-.11-.045.04a.446.446 0 0 0-.138-.076.222.222 0 0 0-.082-.004l-.049.01-.15-.04a.378.378 0 0 0-.068-.09.135.135 0 0 0-.076-.023.093.093 0 0 0-.026-.078.219.219 0 0 0-.06-.043l-.044-.02v-.062l.153-.021.122-.082a.121.121 0 0 1 .072 0 .188.188 0 0 1 .046.031l.031.029h.184v-.06h-.174a.225.225 0 0 0-.042-.062c-.011-.01-.021-.01-.03 0V19.097l.132-.04c.067.048.123.08.166.094a.519.519 0 0 0 .186.02l.02-.007c.01-.01.265-.037.358-.123a.275.275 0 0 0 .088-.14l.005-.05h.068l.02.004a.937.937 0 0 0 .33.052.377.377 0 0 0 .248-.084l.037-.043-.02-.07a.807.807 0 0 1-.315.1c-.046 0-.09-.048-.156-.064a.967.967 0 0 0-.19-.013 1.722 1.722 0 0 0-.171-.096c-.136-.06-.249-.094-.315-.129a.124.124 0 0 1-.063-.067c.042.007.063-.005.063-.035 0-.046-.06.002-.063 0a.257.257 0 0 0-.05-.035l-.092-.046a.668.668 0 0 0-.102-.048l-.069-.024-.222-.113a.169.169 0 0 0-.02-.096.555.555 0 0 0-.057-.066l-.048-.05.104-.164c-.025.008-.043.008-.054 0-.033-.025-.06-.086-.076-.093-.026-.01-.056.065-.072.037a.317.317 0 0 1-.032-.118c-.016-.14.064-.186.24-.135l.082.028.2-.202.632-.742a3.91 3.91 0 0 0 .547-1.083c.054-.17.14-.364.194-.61.044-.206.1-.58.165-1.123.076-.118.138-.277.187-.479a1.1 1.1 0 0 0 .035-.41l-.018-.081.07-.044.136-.028c-.01.044-.01.068 0 .072.007.002.022-.003.045-.017l.04-.027v.074c-.026.064-.026.115 0 .154.039.058.034.032.17.103.05.025.13.017.243-.024.032-.01.04-.118.099-.147a.473.473 0 0 1 .154-.032l.077-.005.237.48-.058.274c.058.069.094.114.108.137.025.042.001.061.029.073.036.017.078.007.124-.029l.048-.044h.237l.06.253v.077l-.068.048-.067-.048-.037.127-.125.124h-.073l-.128.08-.05-.08-.195-.028c-.067.019-.108.039-.121.061-.01.015-.013.04-.01.076l.01.061.205.449-.05.077c.024.038.03.067.015.09-.014.022-.045.028-.091.018.027.068.057.104.091.107.012.001.032-.018.059-.06l.029-.047.108.028-.16.11c.014.018.003.053-.036.103a1.064 1.064 0 0 1-.11.118l-.082.073-.156.054.084.034.061.05h.063l.026.073c.084-.023.134-.032.15-.026l.055.025.055.034.147.114.229-.037.196.088.03.077c.08.022.139.043.174.062.033.017.066.064.095.08.041.022.2-.053.3-.08.062-.017.06.027.12 0 .083-.038.03-.175.154-.27.06-.046.063-.092.133-.14.1-.069.21-.138.317-.2.068-.04.172-.06.236-.13.169-.182.216-.422.217-.425 0 0-.004-.125-.03-.181a.71.71 0 0 0-.074-.099l-.048-.057.057-.037.013-.112h-.588a2.03 2.03 0 0 0-.16-.217c-.029-.031-.05-.047-.063-.046l-.01.006.032-.511.2-.312.183-.02-.029-.051h-.153c-.01-.045-.024-.069-.041-.07-.012-.002-.028.006-.05.023l-.035.033-.075-.008c-.032.063-.064.094-.094.093-.025 0-.14-.071-.355-.113a.156.156 0 0 0-.069.01l-.05.018-.164-.096a.137.137 0 0 1 0-.112.153.153 0 0 1 .066-.064l.06-.028.019-.08c-.025-.026-.037-.047-.037-.06 0-.04.036-.075.037-.123 0-.04-.036-.094-.035-.14l.004-.25c0-.03-.018-.06-.038-.097a.344.344 0 0 1-.045-.176c.001-.029.073-.105.095-.168.01-.03.016-.1.019-.21a.437.437 0 0 1 .138-.235c.066-.064.157-.13.275-.197.014-.008.03-.08.08-.132.034-.036.095-.056.13-.072.066-.031.16-.021.247-.055.065-.024.094-.082.213-.142.052-.027.15-.07.294-.127l.116-.046h.114c.05-.044.155-.08.315-.104.05-.008.123-.014.218-.018.06.013.102.02.129.018.031-.002.064-.036.125-.046.012-.002.036.007.074.028a.171.171 0 0 1 .128-.028c.04.009.113.043.216.102a.63.63 0 0 1 .203-.094l-.1-.293V3.715h-4.498L9.191 1.451 7.096 6.745l1.02 6.83-2.729 6.828 2.144.327.497-.327a.52.52 0 0 1 .205-.09c.033-.01.074-.004.12-.02.044-.016.104-.06.16-.067.037-.006.14.034.306.12l.108.057.087-.01.136.12.134.04.032-.049.29.073.03-.064.11-.065.12-.03.03-.105.01-.055c.063-.024.116-.024.158 0 .063.036.1.178.124.16 0 0 .04-.005.094.03.007.005.015.02.025.045.026-.01.046-.01.06 0a.45.45 0 0 1 .087.1c-.01-.031-.02-.058-.03-.08-.013-.033-.046-.048-.03-.065.007-.008.113.094.148.087.017-.004-.077-.078-.06-.116.006-.01.042-.01.109 0a.164.164 0 0 0 .017-.026l.03.003.038.007.074.15-.045.056a3.95 3.95 0 0 1-.222.233c-.1.074-.199.138-.295.19-.023.012-.095-.015-.124 0-.044.022-.102.103-.199.161-.02.013-.056-.014-.079 0l-.029.018-.04.026-.353-.044c-.014-.012-.023-.035-.027-.07a.983.983 0 0 1 0-.16 1.745 1.745 0 0 1-.272-.063c-.025-.009-.055-.054-.088-.067-.025-.01-.053.013-.083 0a.908.908 0 0 1-.124-.067c-.01.025-.024.04-.042.047a.128.128 0 0 1-.05.004l-.035-.004-.052.043-.05-.014c.022.122.013.19-.028.204a.507.507 0 0 1-.106.024l-.876.68L4 21.218l3.096-7.642-.993-6.831L8.792 0zm.73 19.28c.045.02.072.035.084.046.037.036.04.074.06.098.02.024.033.045.042.063l.008.026-.08.016-.035.041-.047-.02a.344.344 0 0 0-.052-.033l-.014-.004a.14.14 0 0 0-.056.016l-.038.02-.116-.036-.128.088-.053.062v-.09l-.155-.116-.015-.11.087-.021h.102c-.042.023-.025.03.053.021a3.52 3.52 0 0 0 .353-.067zm-.068-.73.054.02c-.02.038-.02.06 0 .067a.272.272 0 0 0 .1-.003l.057-.009.08.046h.196l.106.167c-.002.032.003.052.017.058.009.004.027.006.055.004l.048-.004.092.071.093.019-.03.11a.357.357 0 0 0-.084.061l-.044.039-.028-.014-.241.077-.11-.095c-.056.017-.089.022-.099.018-.066-.033-.051-.049-.05-.054.005-.052-.033-.106-.112-.16a2.11 2.11 0 0 0-.093-.029c-.028-.007-.018-.069-.04-.072-.019-.003-.07.053-.084.054-.03.002-.048.012-.056.03l-.003.035-.162.01c-.126-.1-.143-.196-.05-.287a.344.344 0 0 1 .292-.09l.096.018v-.087zm.576-.431.083.1.003-.002.01.009.04.027c.093.06.244.14.454.235.157.157.291.264.403.321.032.017.066.01.112 0l.05-.012.062.012v.041l-.031-.004c-.018-.002-.028 0-.032.004-.038.048-.042.114-.09.136a.866.866 0 0 1-.28.055c-.025-.031-.107-.065-.246-.102a.32.32 0 0 0-.13-.116.458.458 0 0 0-.149-.016l-.074.002-.125-.2c.024-.12-.009-.204-.098-.254-.133-.074-.337.103-.356.086-.103-.09-.081-.164-.059-.188.015-.017.079-.008.169-.033.034-.01.043-.052.12-.08a.76.76 0 0 1 .164-.021zm5.102-3.682a.16.16 0 0 0 .081.072c.032.012.108.025.227.04a.116.116 0 0 0 .067.052.53.53 0 0 0 .087.015l.066.006.1.146c.03.09.03.164 0 .225a1.72 1.72 0 0 1-.122.204l-.067.098-.103.083a.467.467 0 0 0-.255.046.823.823 0 0 0-.14.109l-.065.06h-.13l-.072.084.025.141c-.017.123-.042.19-.077.205-.17.07-.324.111-.388.065a1.96 1.96 0 0 1-.15-.126l-.069-.064-.36-.173-.179.026-.063-.074v-.137l.164-.162.639-.385.055.007c.08-.051.12-.103.12-.153 0-.034.01-.064.03-.092l.036-.039h.077c.09-.088.16-.148.212-.181.035-.022.08-.005.135-.026a.848.848 0 0 0 .119-.072zm-2.48-2.798.17.24-.068.334-.133.17-.209.178h-.205l.017-.225.12-.316.307-.38zm2.154-1.332.1.072-.12.08-.263.099-.184.022-.19.118-.278.053-.23.137-.067-.103.172-.171 1.06-.307zm1.26-.068.067.045-.1.057-.095-.012-.312.073-.201-.027-.133.06-.16.017-.124-.059v-.086l.098-.049.249.05.61-.058.102-.011z"
  }));
};
var Location = function Location(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.58 11.758a2.177 2.177 0 1 1 0-4.354 2.177 2.177 0 0 1 0 4.354m0-8.758A6.58 6.58 0 0 0 5 9.58C5 15.15 11.58 21 11.58 21s6.582-5.85 6.582-11.42A6.58 6.58 0 0 0 11.58 3"
  }));
};
var ThumbsUp = function ThumbsUp(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 58 69"
  }, props), /*#__PURE__*/React.createElement("title", null, "Thumbs up"), /*#__PURE__*/React.createElement("g", {
    id: "Thumbs-up",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99883665,31.7843145 C7.41834232,30.0745617 7.39773108,30.3805485 10.9988366,28.8843145 C14.5999422,27.3880805 16.06167,27.0500418 18.1988366,25.8843145 C19.0904815,25.3979628 19.820202,24.8243341 20.5488366,24.1634286 C20.9845024,23.7682595 22.8819728,21.7794437 23.5488366,20.8277879 C24.2586546,19.8148341 25.1756722,18.5003429 25.9988366,16.8843145 C28.3936103,12.1829184 28.889513,9.4076237 29.8988366,6.88431453 C30.4506375,5.50481234 31.0206747,4.13576029 31.6089482,2.77715837 C31.8562473,2.20602771 32.1648239,1.47549588 32.9988366,0.88431453 C33.2365758,0.715795602 34.0556054,0.253858312 35.0144255,0.0843145301 C36.0262338,-0.0945989315 37.1937102,0.0296108539 37.9980376,0.28431453 C38.7449403,0.520833719 39.4692925,0.860990256 40.1710941,1.30478414 C40.2879689,1.37869154 41.2393256,2.13799569 41.8988366,3.58269657 C42.290748,4.4412034 42.5040976,4.92788584 42.7988366,6.88431453 C42.9953293,8.18860032 43.0453293,9.52193365 42.9488366,10.8843145 C42.947848,11.8251839 42.6645146,13.1585172 42.0988366,14.8843145 C41.9160014,15.4421169 41.6403041,16.2990156 41.2988366,17.1941099 C40.9325633,18.1542284 40.4965053,19.1582935 40.1988366,19.8843145 C39.1594737,22.4193462 37.7498356,25.6900566 37.4561402,26.5124038 C37.2603433,27.0606352 37.1745754,27.6512721 37.1988366,28.2843145 C37.21217,28.4109812 37.2455033,28.5187344 37.2988366,28.6075742 C37.35217,28.6964139 37.45217,28.821994 37.5988366,28.9843145 C38.7401033,28.7100145 39.6802034,28.5266812 40.4191367,28.4343145 C41.6262088,28.2834305 44.7342553,28.0975232 47.4943878,28.1962584 C50.2545202,28.2949937 51.7465936,28.4428269 52.9988366,28.8843145 C53.8336653,29.1786396 54.540332,29.8453063 55.1188366,30.8843145 C55.3507184,31.5616882 55.477385,32.2303996 55.4988366,32.8904489 C55.5202882,33.5504981 55.4369549,34.21512 55.2488366,34.8843145 C54.956044,35.585751 54.5393773,36.1190843 53.9988366,36.4843145 C53.4582959,36.8495447 52.6416293,37.1495447 51.5488366,37.3843145 C51.46217,37.6709812 51.4455033,37.9376479 51.4988366,38.1843145 C51.55217,38.4309812 51.7188366,38.5976479 51.9988366,38.6843145 C53.0027645,38.7154727 53.6750204,38.7821393 54.0156044,38.8843145 C54.7031375,39.0905745 55.3642149,39.4239078 55.9988366,39.8843145 C56.4980387,40.3674862 56.831372,40.7202741 56.9988366,40.9426784 C57.2459451,41.2708552 57.8988366,42.3863253 57.8988366,43.8843145 C57.8988366,44.882974 57.53217,45.882974 56.7988366,46.8843145 C56.4100652,47.2645006 55.9767318,47.5818962 55.4988366,47.8365013 C55.0209415,48.0911064 54.5157721,48.2737108 53.9833285,48.3843145 L52.6988366,48.3843145 C52.2988366,48.6576479 52.0988366,48.9643145 52.0988366,49.3043145 C52.0988366,49.6443145 52.1655033,49.9376479 52.2988366,50.1843145 L53.4440689,50.6343145 C54.0486381,50.9097065 54.566894,51.3263732 54.9988366,51.8843145 C55.2403033,52.1962176 55.7126861,53.1830494 55.7488366,53.8843145 C55.7849872,54.5855797 55.7892838,54.8412841 55.675362,55.3021772 C55.5409724,55.8458769 55.3321306,56.373256 54.9488366,56.8843145 C54.6880408,57.2320423 54.3421972,57.542124 54.0113058,57.8145598 C53.720974,58.0536013 53.0623839,58.3923099 52.0355354,58.6843145 C51.8426264,58.739172 51.4970601,58.8058387 50.9988366,58.8843145 L49.2488366,58.9843145 C48.96217,59.1509812 48.7955033,59.3509812 48.7488366,59.5843145 C48.70217,59.8176479 48.7855033,60.0643145 48.9988366,60.3243145 L50.0168579,60.6843145 C51.0110333,61.2176479 51.5216929,61.9496429 51.5488366,62.8802998 C51.5895523,64.276285 51.475285,65.4556464 50.0016466,66.7843145 C49.4876586,67.2477386 48.8545536,67.4912052 48.1023318,67.7343145 C47.6452927,67.8820242 46.8607943,68.0486909 45.7488366,68.2343145 L40.0010327,68.6843145 C38.1462353,68.7443145 36.81217,68.7776479 35.9988366,68.7843145 C34.7788366,68.7943145 28.6377735,68.7414839 25.3910307,68.5132824 C22.1442879,68.2850808 21.4236621,68.1168902 18.9258088,67.5843145 C16.4279556,67.0517389 16.0894589,66.9976619 13.9988366,66.0843145 C12.6050885,65.4754163 11.2717551,64.6754163 9.99883665,63.6843145 L5.99912679,59.8445931 C5.6005732,59.505994 5.13964906,59.1744645 4.61635438,58.8500046 C3.83141237,58.3633147 3.44878136,58.2942773 2.99883665,57.9843145 C2.44718062,57.6042838 2.05635486,57.1737105 1.71932092,56.7662516 C1.30382099,56.2639309 0.723401214,54.7703696 0.498836646,53.8721113 C0.239479861,52.8346842 0.182966814,51.4491222 0.134208514,50.425802 C0.00166588165,47.644049 0.0975252306,47.2982714 0.0687602378,44.8458357 C0.0452570713,42.8420109 -0.0277106081,40.4082829 0.0112302522,39.9409643 C0.224109489,37.3862585 0.450803729,36.3915418 0.898836646,34.8843145 C1.09883665,34.2114947 1.78104521,33.1945675 2.17275045,32.889441 C2.5644557,32.5843145 3.13875358,32.2143561 3.99883665,31.7843145 Z",
    id: "Path-2",
    fill: "#FFBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1988366,28.2843145 C36.6491114,28.3570112 36.2566531,28.4236779 36.0214618,28.4843145 C35.0603746,28.7321005 34.3937143,29.0314706 34.021481,29.207818 C33.777778,29.3232735 32.5285093,30.04554 31.6988366,30.8956082 C31.0356177,31.5751308 30.7670551,32.3363186 30.5620165,32.9344937 C29.9561734,34.7019667 30.4904911,36.5989836 30.5988366,36.8981554 C30.8174274,37.5017447 31.0945063,37.9694877 31.2988366,38.4843145 C31.4064264,38.7553957 31.4498365,39.7521385 31.3985954,40.9130014 C31.388536,41.1408948 31.3995111,42.8738523 30.5816296,45.1307691 C30.125032,46.3907349 29.4940749,47.743868 28.6988366,48.906031 C27.6082165,50.4998658 26.3589437,51.7345157 26.1988366,51.8770596 C25.2520649,52.7199732 23.8988366,53.516454 23.3777374,54.1031009 C22.8566381,54.6897478 22.8988366,54.7174426 22.8988366,54.8843145 C22.8988366,55.0643438 22.9342857,55.2139882 23.0063234,55.32641 C23.2544011,55.7135594 23.9363916,55.6592779 25.0988366,54.8843145 C25.8683088,54.3713331 26.8213311,53.5952018 27.5988366,52.8259025 C28.3369913,52.0955388 28.9092218,51.3713331 29.2988366,50.8843145 C29.6096134,50.4958436 30.1890589,49.8244169 30.7488366,48.8700346 C31.0160857,48.4143934 31.4327524,47.5858201 31.9988366,46.3843145 C31.9988366,46.7176479 32.33217,47.2176479 32.9988366,47.8843145 C33.1686748,48.0541527 33.5020081,48.3041527 33.9988366,48.6343145 C33.535822,48.6343145 33.2024887,48.6676479 32.9988366,48.7343145 C31.9774176,49.1343145 31.4345654,49.3440777 30.8488366,49.8843145 C30.1709576,50.5095446 29.6310297,51.1756019 29.3988366,52.3843145 C29.1722814,53.5636787 29.3142136,54.632966 29.6488366,55.5921767 C29.928312,56.3933044 30.3156141,57.1176481 30.9865396,57.7652076 C31.1856402,57.9573742 31.5230725,58.2304098 31.9988366,58.5843145 C30.2988366,59.4509812 29.4488366,60.8843145 29.4488366,62.8843145 C29.4488366,65.8843145 31.4988366,68.7843145 35.9988366,68.7843145 C37.2162866,68.7843145 38.5382158,68.7607397 39.9988366,68.6843145 C41.1579568,68.623665 43.0746234,68.473665 45.7488366,68.2343145 C42.81999,68.0652276 40.9033233,67.948561 39.9988366,67.8843145 C38.4397862,67.7735739 34.9576244,67.4218793 34.5109642,67.2843145 C33.8898949,67.0930342 33.3876529,66.66767 32.9988366,66.3843145 C31.7988366,65.509797 31.6488366,63.8668327 31.6488366,63.3843145 C31.6488366,62.6767971 32.115551,61.4820497 32.7124803,60.9291427 C33.2967248,60.387985 34.101504,59.9827037 34.9988366,59.8343145 C36.8129843,59.5343145 37.8279851,59.6343145 38.9968712,59.6343145 C41.8836014,59.6343145 46.4559662,59.9063364 47.0327603,59.9503801 C47.6352731,59.9963876 48.2906319,60.1194654 48.9988366,60.3196132 C48.7881139,60.0647262 48.7047806,59.8196266 48.7488366,59.5843145 C48.7928927,59.3490025 48.9595594,59.1490025 49.2488366,58.9843145 C41.7042463,58.5910176 37.2875796,58.2576842 35.9988366,57.9843145 C34.0657222,57.57426 33.0783849,56.5232188 32.4988366,55.3843145 C32.1808463,54.7594131 31.9988366,54.0680377 32.1988366,52.8843145 C32.4054546,51.661422 33.0758788,51.154421 33.9988366,50.7343145 C35.0343809,50.2629616 36.2160776,50.213626 38.0168693,50.1343145 C41.4226671,49.9843145 41.9988366,49.8715355 44.9988366,49.8843145 C47.4322993,49.8928339 49.8656327,49.9928339 52.2988366,50.1843145 C52.1655033,49.9452767 52.0988366,49.6535253 52.0988366,49.3090604 C52.0988366,48.9645954 52.2988366,48.6563468 52.6988366,48.3843145 C49.4970675,48.4374708 47.2644784,48.4840975 46.0010696,48.5241946 C42.8267531,48.6249387 40.1650305,48.7843145 38.0159019,48.6090596 C36.5073153,48.3843145 35.5349602,47.7454709 35.0988366,47.3586886 C33.5267511,45.9644623 33.6909724,44.1458838 33.6988366,43.902953 C33.7490538,42.3517256 34.2594453,41.6540102 34.9988366,41.2843145 C36.9988366,40.2843145 38.521019,40.3843145 40.9988366,39.8843145 L51.9988366,38.6843145 C51.7847588,38.5992008 51.6347588,38.4325341 51.5488366,38.1843145 C51.4629145,37.9360949 51.4629145,37.6694283 51.5488366,37.3843145 C48.6830402,37.6590904 46.693269,37.8590904 45.579523,37.9843145 C44.2653604,38.1320725 42.7384649,38.3154059 40.9988366,38.5343145 C38.9988366,38.6009812 37.6749072,38.5733169 37.0270482,38.4513217 C35.0988366,38.2216852 33.4888366,37.4843145 33.4388366,34.8545872 C33.3888366,32.7744565 33.7430954,32.2207578 33.8988366,31.9295788 C34.3117653,31.1575537 34.9128559,30.575799 35.3988366,30.1843145 C36.0681111,29.6451768 36.8014444,29.2451768 37.5988366,28.9843145 C37.4503711,28.8228789 37.3503711,28.6970685 37.2988366,28.6068833 C37.2473022,28.516698 37.2139689,28.4091751 37.1988366,28.2843145 Z",
    id: "Path",
    fill: "#F28700"
  })));
};
var Edit = function Edit(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "m8.332 17.09-.005.001-2.652.604.956-2.542.001-.001.001-.001.857-.744 1.69 1.945-.848.738zm.71.815L20.932 7.577 17.823 4 5.933 14.329l-.01.008.005.005L4.173 19l4.857-1.09-.004-.02.019.02-.002-.005z"
  }));
};
var Export = function Export(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.744 5.476a1.252 1.252 0 1 0 0 2.504h2.752v9.516H6.48v-1.753a1.251 1.251 0 1 0-2.504 0v3.004c0 .693.561 1.253 1.252 1.253h13.52C19.44 20 20 19.44 20 18.747V6.727c0-.69-.56-1.251-1.252-1.251zM9.133 2.385a1.252 1.252 0 0 0-1.77 0L1.773 7.974l5.54 5.54c.49.49 1.281.49 1.77 0l.022-.026a1.25 1.25 0 0 0-.021-1.745L6.568 9.225h1.371c.914 0 2.756.618 4.045 2.763 1.29 2.145.352 2.526.653 2.526.301 0 1.943-1.798.721-4.295-1.71-3.498-4.6-3.498-5.346-3.498H6.568l2.565-2.565a1.253 1.253 0 0 0 0-1.771z"
  }));
};
var ListItem = function ListItem(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 3h4v4H3V3zm0 7h4v4H3v-4zm0 7h4v4H3v-4zm7-14h11v4H10V3zm0 7h11v4H10v-4zm0 7h11v4H10v-4z"
  }));
};
var TimeSeriesManager = function TimeSeriesManager(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M4,3 L4,19 L22,19 L22,21 L2,21 L2,3 L4,3 Z M21.205593,3.52920887 L22.0247451,4.1027853 L15.9984337,15.1373978 L10.8379459,10.3032107 L5.81915204,17.4707911 L5,16.8972147 L10.7357644,8.70569425 L15.8962522,13.5398814 L21.205593,3.52920887 Z"
  }));
};
var Close = function Close(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "m13.805 12 4.821-4.822a1.276 1.276 0 1 0-1.804-1.804L12 10.195 7.178 5.374a1.276 1.276 0 1 0-1.804 1.804L10.196 12l-4.822 4.822a1.276 1.276 0 1 0 1.804 1.805L12 13.805l4.822 4.822a1.274 1.274 0 0 0 1.804 0c.499-.5.499-1.306 0-1.805L13.805 12z"
  }));
};
var KeyOption = function KeyOption(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 12 11"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m4.01.88 4.55 9.11h3.14V11H7.74L3.19 1.9H.06V.88h3.95zm7.69 0V1.9H6.97V.88h4.73z"
  }));
};
var KeyCommand = function KeyCommand(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 12 12"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.04.63c1.04 0 2.15.81 2.15 2.17 0 1-.79 2.13-2.15 2.13H7.9v2.02H9c1.4 0 2.19 1.15 2.19 2.05 0 1.6-1.19 2.26-2.19 2.26S6.89 10.5 6.89 9V7.97H4.86V9c0 1.5-1.11 2.26-2.15 2.26C1.7 11.26.56 10.5.56 9c0-1 .99-2.05 2.15-2.05h1.14V4.93H2.71C1.55 4.93.525 4 .561 2.72.598 1.442 1.7.63 2.71.63c1.04 0 2.15.75 2.15 2.17v1.12h2.03V2.8C6.89 1.38 8 .63 9.04.63zM3.85 7.96H2.71A1.14 1.14 0 1 0 3.85 9.1V7.96zm5.19 0H7.9V9.1a1.14 1.14 0 1 0 1.14-1.14zM6.89 4.93H4.86v2.02h2.03V4.93zM2.71 1.64a1.14 1.14 0 0 0 0 2.28h1.14V2.78c0-.63-.51-1.14-1.14-1.14zm6.33 0c-.63 0-1.14.51-1.14 1.14v1.14h1.14a1.14 1.14 0 0 0 0-2.28z"
  }));
};
var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 12 6"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.355 0 .395 2.96l2.96 2.96V3.47h8.01V2.45h-8.01z"
  }));
};
var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 12 6"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m8.405 5.92 2.96-2.96L8.405 0v2.45H.395v1.02h8.01z"
  }));
};
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 6 12"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m-.08 8.89 2.96 2.96 2.96-2.96H3.39V.88H2.37v8.01z"
  }));
};
var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 6 11"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-.08 2.96 2.88 0l2.96 2.96H3.39v8.01H2.37V2.96z"
  }));
};
var Exclamation = function Exclamation(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.862 16.72c-.22.226-.507.339-.86.339-.364 0-.662-.113-.894-.34-.232-.226-.347-.52-.347-.885 0-.32.118-.59.356-.81a1.25 1.25 0 0 1 .884-.331c.332 0 .613.11.845.33.232.222.347.491.347.811 0 .365-.11.66-.33.886zm.216-9.805-.134 6.669H11.06l-.15-6.67h2.169zM12 4.5a7.501 7.501 0 0 0 0 15 7.5 7.5 0 0 0 0-15z"
  }));
};
var Visibility = function Visibility(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.4980749,15.8618431 C15.8661433,15.0851043 16.779689,13.6936347 16.779689,12.1014551 C16.779689,10.5092755 15.8661433,9.11870594 14.4980749,8.34106705 C17.6257313,9.18620931 19.3529176,11.4300215 19.8092405,12.1014551 C19.3529176,12.7719886 17.6266313,15.0167008 14.4980749,15.8618431 L14.4980749,15.8618431 Z M4.18985949,12.1014551 C4.64618231,11.4300215 6.37336867,9.18710936 9.49922496,8.3419671 C8.13295665,9.11870594 7.21851093,10.5101755 7.21851093,12.1014551 C7.21851093,13.6936347 8.13295665,15.0842042 9.49922496,15.8618431 C6.37336867,15.0167008 4.64618231,12.7728886 4.18985949,12.1014551 L4.18985949,12.1014551 Z M11.99955,13.8583429 C10.9950998,13.8583429 10.180559,13.0717036 10.180559,12.1014551 C10.180559,11.1312066 10.9950998,10.3445672 11.99955,10.3445672 C13.0031002,10.3445672 13.8176409,11.1312066 13.8176409,12.1014551 C13.8176409,13.0717036 13.0031002,13.8583429 11.99955,13.8583429 L11.99955,13.8583429 Z M20.7983899,11.7666383 C20.6813841,11.5713286 17.8696435,7 11.99955,7 C6.12945647,7 3.31681584,11.5713286 3.19980999,11.7666383 L3,12.1014551 L3.19980999,12.4362718 C3.31681584,12.6306815 6.12945647,17.2020101 11.99955,17.2020101 C17.8696435,17.2020101 20.6813841,12.6306815 20.7983899,12.4362718 L21,12.1014551 L20.7983899,11.7666383 Z"
  }));
};
var VisibilityOff = function VisibilityOff(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 15.309c-.755 0-1.45-.088-2.092-.236l.798-.797c.41.124.844.192 1.294.192 2.453 0 4.442-1.988 4.442-4.44 0-.495-.085-.907-.234-1.255l.03-.03c1.72.906 2.781 2.167 3.218 2.766-.724.992-3.151 3.8-7.456 3.8zm-7.456-3.8c.442-.607 1.522-1.89 3.276-2.796-.166.36-.261.79-.261 1.315 0 1.228.499 2.34 1.305 3.144l-1.102 1.104c-1.72-.906-2.78-2.169-3.218-2.767zm5.646-3.524c.818 0 1.482.665 1.482 1.483 0 .818-.664 1.481-1.482 1.481s-1.482-.663-1.482-1.481c0-.818.664-1.483 1.482-1.483zm10.608 3.19c-.073-.125-1.245-2.026-3.603-3.388l2.009-2.01c.406-.406.406-1.065 0-1.473-.407-.405-1.066-.405-1.473 0l-2.58 2.582c-.93-.295-1.98-.478-3.151-.478-5.87 0-8.681 4.57-8.798 4.766L3 11.51l.202.335c.073.124 1.244 2.025 3.603 3.387l-2.009 2.01c-.406.406-.406 1.065 0 1.472.204.203.47.305.737.305.266 0 .532-.102.736-.305l2.58-2.58c.93.293 1.98.476 3.151.476 5.87 0 8.681-4.57 8.798-4.765l.202-.335-.202-.335z"
  }));
};
var HamburgerMenu = function HamburgerMenu(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.693 7.732H5.306C4.584 7.732 4 7.12 4 6.366 4 5.611 4.584 5 5.306 5h13.387C19.414 5 20 5.611 20 6.366c0 .754-.586 1.366-1.307 1.366m0 5.634H5.306C4.584 13.366 4 12.754 4 12c0-.755.584-1.367 1.306-1.367h13.387c.721 0 1.307.612 1.307 1.367 0 .753-.586 1.365-1.307 1.365m0 5.634H5.306C4.584 19 4 18.388 4 17.634c0-.754.584-1.367 1.306-1.367h13.387c.721 0 1.307.613 1.307 1.367S19.414 19 18.693 19"
  }));
};
var GeoWebLogo = function GeoWebLogo() {
  return /*#__PURE__*/React.createElement("svg", {
    id: "svg4550",
    style: {
      width: 44,
      height: 30
    },
    xmlns: "http://www.w3.org/2000/svg,Rdf:http://www.w3.org/1999/02/22-rdf-syntax-ns#,Cc:http://creativecommons.org/ns#,Dc:http://purl.org/dc/elements/1.1/",
    height: "55.156mm",
    viewBox: "0 0 289.84072 195.43326",
    width: "81.799mm",
    version: "1.1",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4263",
    y2: "113.1",
    gradientUnits: "userSpaceOnUse",
    y1: "76.066",
    gradientTransform: "translate(0 -.0012816)",
    x2: "199.26",
    x1: "160.9"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4259",
    stopColor: "#fff",
    stopOpacity: ".33333",
    offset: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4261",
    stopColor: "#fff",
    stopOpacity: "0",
    offset: "1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4240",
    y2: "79.833",
    gradientUnits: "userSpaceOnUse",
    x2: "120.82",
    y1: "120.77",
    x1: "128.56"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4236",
    stopColor: "#fff",
    stopOpacity: "0",
    offset: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4238",
    stopColor: "#fff",
    stopOpacity: ".33333",
    offset: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(353.49 -626.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4220",
    d: "m-207 679.86c-7.6546-3.9726-16.149-6.0541-24.773-6.0703-24.585 0.0315-46.045 16.665-52.207 40.465-2.23-0.35755-4.4838-0.54689-6.7422-0.56642-24.881-0.00043-45.051 20.17-45.051 45.051-0.00043 24.881 20.17 45.051 45.051 45.051 36.152-0.20272 72.845-0.0898 109.18-0.0898 8.9834 0 22.962 0.009 36.879 0.0165 9.7409 0.38215 35.645-0.43398 53.537-23.548 17.892-23.115 7.1203-72.79-0.31513-94.017s-30.566-42.361-53.247-42.361c-26.664 0-50.367 14.562-62.311 36.07z",
    fill: "#0b9ee5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4220-7",
    opacity: ".98",
    d: "m-335.78 758.74c-0.00043 24.881 20.17 45.051 45.051 45.051 36.152-0.20272 72.845-0.0898 109.18-0.0898 10.101 0 27.126 0.009 42.523 0.0156 11.975-0.4199 32.775-4.017 47.893-23.547 4.439-5.7347 7.1108-13.107 8.5098-21.271-35.448-0.0105-239.67-0.15823-253.16-0.15823z",
    fill: "#60bce9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path4220-2",
    d: "m-144.69 643.79c-19.529 0-37.464 7.8167-50.359 20.447-4.6476 4.6419-8.6513 9.9041-11.953 15.623 0 40.944 0.0195 77.914 0.0195 123.83 8.4824 0.007 16.983 0.0137 25.438 0.0137 10.101 0 27.126 0.009 42.523 0.0156 11.975-0.4199 32.775-4.017 47.893-23.547 17.892-23.115 7.1209-72.791-0.31446-94.018s-30.565-42.361-53.246-42.361z",
    fill: "#fff",
    fillOpacity: ".31373"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4244",
    transform: "translate(2.926 -1.3827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4329",
    fill: "#003232",
    d: "m211.54 98.88c11.484 8.7901 14.857 8.43 22.486 19.238 3.6519 5.1733 5.5602 11.69 5.5645 18.164-0.00018 17.949-14.551 32.499-32.5 32.498-17.948-0.00018-32.498-14.55-32.498-32.498 0.006-0.50098 0.0236-1.0018 0.0527-1.502-3.4629-1.1175-6.9173-1.9297-9.6543-1.9297-2.7565 0-6.2409 0.82134-9.7285 1.9512 0.036 0.49286 0.0607 0.98649 0.0742 1.4805-0.00018 17.948-14.55 32.498-32.498 32.498-17.948-0.00019-32.498-14.55-32.498-32.498 0.006-3.5239 0.71774-6.9687 1.8781-10.26 5.474-20.521 8.7944-44.229 27.665-46.855 8.2552-1.1488 15.952 8.848 25.107 8.848 9.1558-0.00028 9.318-14.58 23.088-14.836 16.828-0.3123 31.185 16.304 43.462 25.701zm-4.7539 13.92c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-84.125 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4329-2",
    fill: "url(#linearGradient4263)",
    d: "m157.24 77.869c-2.1199 2.1753-3.6401 4.4832-5.4018 6.5241-0.53185 0.61614-1.2448 1.3191-1.8477 1.7949-1.2058 0.9517-2.5477 1.6107-4.168 1.7793-0.27005 0.0281-0.54787 0.04296-0.83398 0.04297 5.0928 13.298 11.821 26.014 20 44.834 2.737 0 6.1914 0.8122 9.6543 1.9297-0.0291 0.5002-0.0467 1.001-0.0527 1.502 0 8.4131 3.196 16.08 8.4414 21.852 0.34969 0.38474 0.70861 0.75939 1.0762 1.127 5.881 5.8809 14.007 9.5194 22.98 9.5195 0.5609 0.00004 1.118-0.0149 1.6719-0.043 3.3236-0.16829 6.5154-0.83435 9.502-1.9277 0.99554-0.36446 1.9688-0.77802 2.916-1.2344 1.4208-0.68453 2.7833-1.4677 4.0801-2.3438 8.645-5.84 14.33-15.731 14.33-26.949-0.004-6.474-2.0849-12.873-5.5645-18.164-7.0668-10.745-14.684-12.763-22.486-19.238-11.815-9.8048-26.968-25.716-42.627-25.716-6.2104 0-9.3385 2.3185-11.67 4.7112zm49.543 34.924c4.9706 0 9.5876 1.5119 13.418 4.0996 0.6384 0.43129 1.255 0.89176 1.8476 1.3809 0.59266 0.4891 1.1622 1.0059 1.7051 1.5488 4.3431 4.3431 7.0293 10.343 7.0293 16.971 0 12.841-10.085 23.326-22.766 23.969-0.40906 0.0207-0.82015 0.0312-1.2344 0.0312-4.97 0-9.5878-1.5105-13.418-4.0976-0.00044-0.0003-0.002 0.00029-0.002 0-6.384-4.3129-10.58-11.618-10.58-19.902 0-6.6275 2.6862-12.628 7.0293-16.971 0.54288-0.54289 1.1124-1.0597 1.7051-1.5488 0.59266-0.4891 1.2073-0.94957 1.8457-1.3809 3.8304-2.5878 8.4493-4.0996 13.42-4.0996z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4329-7",
    d: "m121.43 79.077c-0.51208-0.01011-1.027 0.01805-1.543 0.08985-18.871 2.626-22.19 26.335-27.664 46.856-1.1604 3.2913-1.8729 6.7359-1.8789 10.26 0 17.948 14.55 32.498 32.498 32.498s32.498-14.55 32.498-32.498c-0.0135-0.49402-0.0382-0.98762-0.0742-1.4805 3.5012-1.0071 5.7853-1.8693 9.6893-1.9248-4.8944-11.377-14.29-31.914-19.961-44.863-8.5828 0.000001-15.883-8.7859-23.565-8.9376zm1.2344 33.723c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z",
    fill: "url(#linearGradient4240)"
  })));
};
var Add = function Add(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.226 13.225h6.549a1.225 1.225 0 1 0 0-2.45h-6.55v-6.55a1.225 1.225 0 1 0-2.45 0v6.55h-6.55a1.225 1.225 0 1 0 0 2.45h6.55v6.55A1.224 1.224 0 0 0 12 21c.677 0 1.225-.548 1.225-1.225v-6.55z"
  }));
};
var Clock = function Clock(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.485 3.717a9 9 0 1 1 7.033 16.569 9 9 0 0 1-7.033-16.57zm.74 1.744a7.105 7.105 0 1 0 5.552 13.08 7.105 7.105 0 0 0-5.552-13.08zm1.825 1.522h1.894v4.734l3.049 1.76-.947 1.641-2.606-1.504h-1.39V6.983z"
  }));
};
var Success = function Success(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "m16.51 10.034-5.633 5.633-3.387-3.386a.954.954 0 0 1 0-1.343.975.975 0 0 1 1.342 0l2.045 2.046 4.292-4.291a.972.972 0 0 1 1.342 0c.368.369.368.97 0 1.341M12 4a8 8 0 1 0 0 16.001A8 8 0 0 0 12 4"
  }));
};
var Cancel = function Cancel(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 16.105a7.105 7.105 0 0 0 5.681-11.373l-9.949 9.95A7.074 7.074 0 0 0 12 19.104zm0-14.21a7.105 7.105 0 0 0-5.681 11.373l9.949-9.95A7.074 7.074 0 0 0 12 4.896z"
  }));
};
var DragHandle = function DragHandle(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm-5 5.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm5 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
  }));
};
var AutoUpdateActive = function AutoUpdateActive(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.385 3.295l5 3-5 3V7.723l-.085.014c-3.08.548-5.418 3.24-5.418 6.479 0 3.634 2.945 6.58 6.577 6.58 2.914 0 5.385-1.896 6.248-4.523l2.815-1.626c-.225 4.814-4.197 8.648-9.063 8.648-5.012 0-9.074-4.065-9.074-9.08 0-4.65 3.495-8.484 8-9.015V3.295z",
    transform: "translate(0.2,1.2) rotate(30 13.454 13.295)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 700,
    fontSize: 6
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.2,
    y: 17.3
  }, "AUTO"))));
};
var AutoUpdateInActive = function AutoUpdateInActive(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.172 3.109l.214 2.455 2.792 1.675-2.514 1.508 1.095 12.499c1.763-.729 3.141-2.202 3.742-4.028l2.815-1.626c-.182 3.872-2.787 7.11-6.332 8.228l.193 2.201-1.992.175-.174-1.988c-.25.02-.503.031-.759.031-5.011 0-9.074-4.065-9.074-9.079 0-4.65 3.495-8.484 8-9.016V4.24l.09.054-.088-1.01 1.992-.174zm-1.995 5.559l.149-.023c-3.193.45-5.65 3.196-5.65 6.515 0 3.634 2.944 6.58 6.576 6.58.182 0 .363-.007.54-.021L13.758 9.89l-.579.348V8.668z",
    transform: "rotate(30 13.454 13.295)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 700,
    fontSize: 6
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 9.2,
    y: 17.3
  }, "AUTO"))));
};
var Pause = function Pause(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.579 4c.865 0 1.565.7 1.565 1.564v12.87c0 .866-.7 1.566-1.565 1.566-.863 0-1.565-.7-1.565-1.565v-4.87H7v-3.13h.014V5.564C7.014 4.7 7.716 4 8.579 4zm6.915 0c.865 0 1.565.7 1.565 1.564v12.871c0 .865-.7 1.565-1.565 1.565-.863 0-1.565-.7-1.565-1.565v-4.87h-.014v-3.13h.014v-4.87C13.93 4.7 14.631 4 15.494 4z"
  }));
};
var Play = function Play(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.18 12.688l-3.909 2.81c-.161.115-.325.175-.486.175-.303 0-.629-.234-.629-.748v-5.85c0-.514.325-.747.63-.747.16 0 .324.059.485.174l3.91 2.81c.24.172.378.423.378.688 0 .265-.137.517-.379.688M12 4c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8"
  }));
};
var Info = function Info(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.0004012,4 C16.4182338,4 20,7.58096384 20,11.9995988 C20,16.4182338 16.4182338,20 12.0004012,20 C7.58176621,20 4,16.4182338 4,11.9995988 C4,7.58096384 7.58176621,4 12.0004012,4 Z M13.0518404,10 L10,10 L10,11.6134693 L10.9489304,11.6134693 L10.9489304,15.3873607 L10,15.3873607 L10,17 L14,17 L14,15.3873607 L13.0518404,15.3873607 L13.0518404,10 Z M11.9907922,6 C11.1541947,6 10.5,6.65419468 10.5,7.49079217 C10.5,8.32738965 11.1541947,9 11.9907922,9 C12.8273897,9 13.5,8.32738965 13.5,7.49079217 C13.5,6.65419468 12.8273897,6 11.9907922,6 Z"
  }));
};
var TextIcon = function TextIcon(_a) {
  var _a$text = _a.text,
      text = _a$text === void 0 ? '0.5x' : _a$text,
      props = __rest(_a, ["text"]);

  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Black, Roboto",
    fontSize: 12,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: text.length > 2 ? 1 : 5,
    y: 16
  }, text)));
};
var FastForward = function FastForward(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.1 5.86c.247 0 .5.089.745.267l6.008 4.316c.368.265.58.65.58 1.057 0 .408-.211.793-.581 1.058l-6.005 4.316c-.248.177-.5.267-.747.267-.466 0-.967-.36-.967-1.147v-3.016l-5.419 3.896c-.207.148-.417.234-.624.26l-.124.007c-.465 0-.966-.36-.966-1.147V7.006c0-.787.5-1.147.966-1.147.247 0 .5.09.746.268l5.421 3.894V7.006c0-.735.436-1.097.873-1.142z"
  }));
};
var SliderThumb = function SliderThumb(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(6.5 5.5)",
    points: "6,0 11,5 11,12 0,12 0,5"
  }));
};
var Options = function Options(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 16c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0-2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
  }));
};
var ChevronLeft = function ChevronLeft(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.42691853,15.0304428 C3.85769382,15.6484814 3.85769382,16.5998089 4.42691853,17.2178475 C4.99671078,17.8207176 5.92075589,17.8207176 6.48948111,17.2178475 L12.002808,11.3748094 L17.5150678,17.2178475 C18.0859271,17.8207176 19.0089052,17.8207176 19.5776304,17.2178475 C19.8625265,16.9148119 20.0044707,16.518945 20.0044707,16.1241452 C20.0069177,15.7184762 19.8542266,15.3272053 19.5776304,15.0304428 L12.002808,7 L4.42691853,15.0304428 Z",
    transform: "translate(12.002235, 12.335000) rotate(-90.000000) translate(-12.002235, -12.335000) "
  }));
};
var ChevronRight = function ChevronRight(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.42691853,15.0304428 C3.85769382,15.6484814 3.85769382,16.5998089 4.42691853,17.2178475 C4.99671078,17.8207176 5.92075589,17.8207176 6.48948111,17.2178475 L12.002808,11.3748094 L17.5150678,17.2178475 C18.0859271,17.8207176 19.0089052,17.8207176 19.5776304,17.2178475 C19.8625265,16.9148119 20.0044707,16.518945 20.0044707,16.1241452 C20.0069177,15.7184762 19.8542266,15.3272053 19.5776304,15.0304428 L12.002808,7 L4.42691853,15.0304428 Z",
    transform: "translate(12.002235, 12.335000) rotate(90.000000) translate(-12.002235, -12.335000) "
  }));
};
var ChevronUp = function ChevronUp(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.42691853,15.0304428 C3.85769382,15.6484814 3.85769382,16.5998089 4.42691853,17.2178475 C4.99671078,17.8207176 5.92075589,17.8207176 6.48948111,17.2178475 L12.002808,11.3748094 L17.5150678,17.2178475 C18.0859271,17.8207176 19.0089052,17.8207176 19.5776304,17.2178475 C19.8625265,16.9148119 20.0044707,16.518945 20.0044707,16.1241452 C20.0069177,15.7184762 19.8542266,15.3272053 19.5776304,15.0304428 L12.002808,7 L4.42691853,15.0304428 Z",
    transform: "translate(12.002235, 12.335000) translate(-12.002235, -12.335000) "
  }));
};
var ChevronDown = function ChevronDown(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.42691853,15.0304428 C3.85769382,15.6484814 3.85769382,16.5998089 4.42691853,17.2178475 C4.99671078,17.8207176 5.92075589,17.8207176 6.48948111,17.2178475 L12.002808,11.3748094 L17.5150678,17.2178475 C18.0859271,17.8207176 19.0089052,17.8207176 19.5776304,17.2178475 C19.8625265,16.9148119 20.0044707,16.518945 20.0044707,16.1241452 C20.0069177,15.7184762 19.8542266,15.3272053 19.5776304,15.0304428 L12.002808,7 L4.42691853,15.0304428 Z",
    transform: "translate(12.002235, 12.335000) rotate(180.000000) translate(-12.002235, -12.335000) "
  }));
};
var Layers = function Layers(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.0513516,15.3519052 L22,17.2314624 L12,22 L2,17.2314624 L6.03531364,15.3519052 L12,18.18517 L18.0513516,15.3519052 Z M18.0513516,10.2257273 L22,12.1052846 L12,16.8738221 L2,12.1052846 L6.03531364,10.2257273 L12,13.0589921 L18.0513516,10.2257273 Z M12,2 L22,7.00696444 L12,11.775502 L2,7.00696444 L12,2 Z"
  }));
};
var Copy = function Copy(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 7v2H6a1 1 0 0 0-.993.883L5 10v9a1 1 0 0 0 .883.993L6 20h6a1 1 0 0 0 .993-.883L13 19h2v1.6a1.4 1.4 0 0 1-1.263 1.394l-.135.006H4.399a1.4 1.4 0 0 1-1.393-1.265L3 20.6V8.4a1.4 1.4 0 0 1 1.264-1.394L4.4 7H8zm7.584-5v2H12a1 1 0 0 0-.993.883L11 5v9a1 1 0 0 0 .883.993L12 15h6a1 1 0 0 0 .993-.883L19 14V7.42h2v8.18a1.4 1.4 0 0 1-1.263 1.394l-.135.006h-9.203a1.4 1.4 0 0 1-1.393-1.265L9 15.6V3.4a1.4 1.4 0 0 1 1.264-1.394L10.4 2h5.185zM17 2l4 4h-2.5c-.777 0-1.42-.598-1.493-1.357L17 4.499V2z"
  }));
};
var Filter = function Filter(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.155 12.567c1.362 0 2.523.848 2.992 2.043h1.895a1.173 1.173 0 0 1 0 2.346h-1.895A3.213 3.213 0 0 1 14.155 19a3.213 3.213 0 0 1-2.992-2.044h-5.99a1.172 1.172 0 1 1 0-2.346h5.99a3.214 3.214 0 0 1 2.992-2.043zm0 1.755a1.461 1.461 0 1 0 0 2.922 1.461 1.461 0 0 0 0-2.922zM10.06 5c1.362 0 2.524.848 2.992 2.044h5.99a1.173 1.173 0 1 1 0 2.344h-5.99a3.214 3.214 0 0 1-2.992 2.044 3.216 3.216 0 0 1-2.992-2.044H5.173a1.172 1.172 0 1 1 0-2.344h1.895A3.216 3.216 0 0 1 10.06 5zm0 1.754a1.461 1.461 0 1 0 0 2.922 1.461 1.461 0 0 0 0-2.922z"
  }));
};
var Clear = function Clear(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M15.44426,7.26697571 L12.0002861,10.7110482 L8.55573996,7.26697571 C8.19978253,6.9110081 7.62292549,6.9110081 7.26696807,7.26697571 C6.91101064,7.62294331 6.91101064,8.19981687 7.26696807,8.55578447 L10.7115142,11.9998569 L7.26696807,15.4445017 C6.91101064,15.8004693 6.91101064,16.3767705 7.26696807,16.7333104 C7.44494678,16.910722 7.67843653,17 7.91192629,17 C8.14484377,17 8.37776125,16.910722 8.55573996,16.7333104 L12.0002861,13.289238 L15.44426,16.7333104 C15.6222388,16.910722 15.8551562,17 16.088646,17 C16.3221357,17 16.5550532,16.910722 16.7330319,16.7333104 C17.0889894,16.3767705 17.0889894,15.8004693 16.7330319,15.4445017 L13.289058,11.9998569 L16.7330319,8.55578447 C17.0889894,8.19981687 17.0889894,7.62294331 16.7330319,7.26697571 C16.3770745,6.9110081 15.8002175,6.9110081 15.44426,7.26697571 Z"
  }));
};
var Search = function Search(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.81701445,12.5845372 L7.81701445,12.5845372 C7.17924024,11.946763 6.82932049,11.100321 6.82932049,10.1993044 C6.82932049,9.29828785 7.17924024,8.45077582 7.81701445,7.8140717 C8.47405029,7.15703585 9.3376137,6.82851792 10.2022472,6.82851792 C11.0658106,6.82851792 11.929374,7.15703585 12.5874799,7.8140717 C13.9026217,9.12921348 13.9026217,11.2693954 12.5874799,12.5845372 C11.9497057,13.2212413 11.1021937,13.5722311 10.2022472,13.5722311 C9.3012306,13.5722311 8.45371857,13.2212413 7.81701445,12.5845372 M19.5858748,17.581862 L15.4681648,13.465222 C16.9513109,11.0735688 16.6613162,7.88683788 14.5874799,5.81300161 C12.1690744,3.39566613 8.23434992,3.39566613 5.81594436,5.81300161 C4.64419476,6.9847512 4,8.54280364 4,10.1993044 C4,11.8558052 4.64419476,13.4138577 5.81594436,14.5845372 C6.98769395,15.7562868 8.5446763,16.4015516 10.2022472,16.4015516 C11.376137,16.4015516 12.4965222,16.0719636 13.4681648,15.4662921 L17.5837346,19.582932 C17.8608882,19.8590155 18.2225789,19.9970572 18.5853398,19.9970572 C18.9470305,19.9970572 19.3087212,19.8590155 19.5858748,19.582932 C20.1380417,19.029695 20.1380417,18.135099 19.5858748,17.581862"
  }));
};
var Flag = function Flag(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.257 7.703c1.295-1.416 2.854-2.124 4.679-2.124 1.97 0 1.676 1.718 3.821 1.61 1.43-.073 2.847-.803 4.25-2.189v10c-1.554 1.47-2.971 2.213-4.25 2.228-1.918.023-1.632-1.61-3.821-1.61-1.46 0-3.02.795-4.679 2.382V7.703zM5.507 4a1.501 1.501 0 0 1 .75 2.803V20h-1.5L4.756 6.803A1.502 1.502 0 0 1 5.507 4z"
  }));
};
var Resize = function Resize(_a) {
  var _a$isRightAligned = _a.isRightAligned,
      isRightAligned = _a$isRightAligned === void 0 ? false : _a$isRightAligned,
      props = __rest(_a, ["isRightAligned"]);

  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    sx: Object.assign(Object.assign({
      width: 20,
      height: 20,
      top: -10,
      position: 'relative'
    }, isRightAligned ? {
      left: 10,
      transform: 'rotate(90deg)'
    } : {
      left: -10
    }), {
      zIndex: 1
    }),
    "data-testid": "resizeHandle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.687 18.037v1h-6v-1h6zm3.5-3.5v1h-13v-1h13z",
    transform: "rotate(-45 16.687 16.787)"
  }));
};
var PresetWorkspace = function PresetWorkspace(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22,2 L22,22 L2,22 L2,2 L22,2 Z M9,12 L4.5,12 L4.5,19.5 L9,19.5 L9,12 Z M19.5,12 L11,12 L11,19.5 L19.5,19.5 L19.5,12 Z M19.5,6 L4.5,6 L4.5,10 L19.5,10 L19.5,6 Z"
  }));
};
var Preset = function Preset(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M22,2 L22,22 L2,22 L2,2 L22,2 Z M19.5,6 L4.5,6 L4.5,19.5 L19.5,19.5 L19.5,6 Z"
  }));
};
var PresetTiles = function PresetTiles(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M22,2 L22,22 L2,22 L2,2 L22,2 Z M7.5,13.24 L4.5,13.24 L4.5,19.48 L7.5,19.48 L7.5,13.24 Z M15.5,13.24 L12.5,13.24 L12.5,19.48 L15.5,19.48 L15.5,13.24 Z M11.5,13.24 L8.5,13.24 L8.5,19.48 L11.5,19.48 L11.5,13.24 Z M19.5,13.24 L16.5,13.24 L16.5,19.48 L19.5,19.48 L19.5,13.24 Z M7.5,6 L4.5,6 L4.5,12.24 L7.5,12.24 L7.5,6 Z M15.5,6 L12.5,6 L12.5,12.24 L15.5,12.24 L15.5,6 Z M11.5,6 L8.5,6 L8.5,12.24 L11.5,12.24 L11.5,6 Z M19.5,6 L16.5,6 L16.5,12.24 L19.5,12.24 L19.5,6 Z"
  }));
};
var List = function List(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5,16 C5.88071187,16 7,17.1192881 7,18.5 C7,19.8807119 5.88071187,21 4.5,21 C3.11928813,21 2,19.8807119 2,18.5 C2,17.1192881 3.11928813,16 4.5,16 Z M22,18 L22,20 L9,20 L9,18 L22,18 Z M7,9 L7,14 L2,14 L2,9 L7,9 Z M22,11 L22,13 L9,13 L9,11 L22,11 Z M4.5,2 L7,7 L2,7 L4.5,2 Z M22,4 L22,6 L9,6 L9,4 L22,4 Z"
  }));
};
var Home = function Home(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.5857657,15.5482973 L14.5857657,19 L19,19 L19,11.1704471 L12.0003998,5 L5,11.1704471 L5,19 L9.41503399,19 L9.41503399,15.5482973 C9.41503399,14.0740894 10.5785686,12.8676932 12.0003998,12.8676932 C13.4222311,12.8676932 14.5857657,14.0740894 14.5857657,15.5482973 Z"
  }));
};
var Minus = function Minus(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M13,11 L11,11 L8,11 C7.43301962,11 7,11.4597824 7,12.0268006 C7,12.5938188 7.43301962,13 8,13 L11,13 L13,13 L16,13 C16.5669804,13 17,12.5938188 17,12.0268006 C17,11.4597824 16.5669804,11 16,11 L13,11 Z"
  }));
};
var Sort = function Sort(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.5,20 L5.5,22 L3,22 L3,20 L5.5,20 Z M17,2 L20,6 L18,6 L18,18 L20,18 L17,22 L14,18 L16,18 L16,6 L14,6 L17,2 Z M7,15.5 L7,17.5 L3,17.5 L3,15.5 L7,15.5 Z M8.5,11 L8.5,13 L3,13 L3,11 L8.5,11 Z M10,6.5 L10,8.5 L3,8.5 L3,6.5 L10,6.5 Z M11.5,2 L11.5,4 L3,4 L3,2 L11.5,2 Z"
  }));
};
var Equalizer = function Equalizer(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M5,2 L5.00043449,14.0500973 C6.14133817,14.2819003 7,15.2906746 7,16.5 C7,17.3174727 6.60764218,18.0433054 6.00097133,18.4994531 L6,22 L3,22 L3.00004507,18.5002169 C2.39279608,18.0441159 2,17.3179292 2,16.5 C2,15.2903182 2.85916789,14.2813059 4.00057405,14.0498926 L4,2 L5,2 Z M12.5,2 L12.5004345,5.05009729 C13.6413382,5.28190033 14.5,6.29067455 14.5,7.5 C14.5,8.31747272 14.1076422,9.04330535 13.5009713,9.49945313 L13.5,22 L10.5,22 L10.5000451,9.50021694 C9.89279608,9.04411586 9.5,8.31792915 9.5,7.5 C9.5,6.29031824 10.3591679,5.2813059 11.500574,5.0498926 L11.5,2 L12.5,2 Z M20,2 L20.0004345,11.0500973 C21.1413382,11.2819003 22,12.2906746 22,13.5 C22,14.3174727 21.6076422,15.0433054 21.0009713,15.4994531 L21,22 L18,22 L18.0000451,15.5002169 C17.3927961,15.0441159 17,14.3179292 17,13.5 C17,12.2903182 17.8591679,11.2813059 19.000574,11.0498926 L19,2 L20,2 Z"
  }));
};
var Link = function Link(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "m11 9-4.128-.018a.921.921 0 0 0-.91.82l-.006.108v4.18c0 .476.354.87.81.923l.106.007H11V17H6.872c-1.528 0-2.78-1.212-2.867-2.74L4 14.09V9.91c0-1.55 1.198-2.817 2.704-2.905L6.872 7H11v2zm5 3a1 1 0 0 1-1 1H9a1 1 0 0 1 0-2h6a1 1 0 0 1 1 1zm4 2.09c0 1.607-1.288 2.91-2.872 2.91H13v-1.98h4.128a.924.924 0 0 0 .916-.93V9.91a.923.923 0 0 0-.916-.928L13 9V7h4.128C18.712 7 20 8.303 20 9.91v4.18z"
  }));
};
var LinkOff = function LinkOff(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "m20.693 18.631-1.285 1.532L15.638 17H13v-1.98l.277-.001-2.406-2.02L9 13a1 1 0 0 1-.41-1.913L6.314 9.175a.93.93 0 0 0-.35.627l-.007.108v4.18c0 .476.354.87.81.923l.106.007H11V17H6.872c-1.528 0-2.78-1.212-2.867-2.74L4 14.09V9.91c0-.778.302-1.486.795-2.008l-2.24-1.88L3.84 4.49 6.834 7H11v2l-1.794-.008L11.6 11H15a1 1 0 0 1 0 2h-1.018l2.407 2.019h.739a.924.924 0 0 0 .916-.93V9.91a.923.923 0 0 0-.916-.928L13 9V7h4.128C18.712 7 20 8.303 20 9.91v4.18a2.915 2.915 0 0 1-1.606 2.612l2.3 1.93z"
  }));
};
var Cached = function Cached(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "m19.691 9.79-1.771 1.225a6 6 0 0 1-6.355 6.969v-3.088l-2.681 1.86c-1.223.86-1.923 1.345-2.1 1.458l-.029.019-.31.215L11.564 22v-2.012A8 8 0 0 0 19.691 9.79zM12.564 2v2.02a8 8 0 0 0-8.237 10.255l1.765-1.223a6 6 0 0 1 6.473-7.026v3.078l2.592-1.798h-.003l2.029-1.4a8.063 8.063 0 0 0-.004-.004l.504-.35L12.564 2z"
  }));
};
var CalendarToday = function CalendarToday(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.342 6.437v1.115c0 .673.548 1.22 1.22 1.22h.06c.671 0 1.22-.547 1.22-1.22V6.437h4.313v1.115c0 .673.548 1.22 1.22 1.22h.058c.673 0 1.22-.547 1.22-1.22V6.437h1.058a2.292 2.292 0 0 1 2.286 2.285v7.993A2.292 2.292 0 0 1 17.71 19H6.285A2.292 2.292 0 0 1 4 16.715V8.722a2.292 2.292 0 0 1 2.285-2.285h1.057zm9.444 7.637a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881zm-4.788 0a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88zm-4.787 0a1.44 1.44 0 1 0-.002 2.88 1.44 1.44 0 0 0 .002-2.88zm9.575-3.897a1.44 1.44 0 1 0-.001 2.881 1.44 1.44 0 0 0 0-2.88zm-4.788 0a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88zM8.62 4.73c.264 0 .478.214.478.478v2.344a.477.477 0 0 1-.478.477h-.058a.478.478 0 0 1-.478-.477V5.208c0-.264.214-.478.478-.478zm6.812 0c.264 0 .478.214.478.478v2.344a.478.478 0 0 1-.478.477h-.057a.478.478 0 0 1-.478-.477V5.208c0-.264.214-.478.478-.478z"
  }));
};
var WebAssetOff = function WebAssetOff(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.89856955,4.50717511 L9.893,8.5 L6,8.5 L6,17 L18,17 L18,16.606 L19.9956851,18.6017419 C19.956118,18.649691 19.9142229,18.6957771 19.87,18.74 C19.4544824,19.1555176 18.8311491,19.4088509 18,19.5 L6,19.5 C5.1805214,19.4148333 4.56096049,19.1624284 4.1413173,18.7427852 C3.7216741,18.323142 3.50790167,17.7422136 3.5,17 L3.5,7 C3.52565636,6.18855517 3.73942879,5.5818885 4.1413173,5.18 C4.52680219,4.79451511 5.11255294,4.57024015 5.89856955,4.50717511 Z M18,4.5 C18.81657,4.52323671 19.4399034,4.74990338 19.87,5.18 C20.3000966,5.61009662 20.5100966,6.21676329 20.5,7 L20.5,16.278 L18,13.778 L18,8.5 L12.721,8.5 L8.721,4.5 L18,4.5 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) ",
    x: "11",
    y: "0",
    width: "2",
    height: "24"
  })));
};
var Notifications = function Notifications(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.436 17.083a1.444 1.444 0 1 1-2.871 0zM12 4c3.094 0 5.61 2.48 5.61 5.53v2.98c0 1.569 1.197 2.663 1.208 2.672.169.15.227.388.145.598a.55.55 0 0 1-.514.348H5.551a.552.552 0 0 1-.514-.348.536.536 0 0 1 .146-.598c.01-.01 1.206-1.103 1.206-2.672V9.53C6.39 6.48 8.907 4 12 4z"
  }));
};
var Update = function Update(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "m8.73 3.39-.252.098a9.5 9.5 0 1 0 9.4 16.303l-1.391-1.455a7.5 7.5 0 1 1 2.504-8.85l.071.185-3.535 1.427 3.117 2.043v-.005l2.579 1.696.933.612 1.75-7.731-2.99 1.209-.071-.184A9.5 9.5 0 0 0 8.73 3.391zM13.04 7h-2V12l-3.218 1.857 1 1.732 2.749-1.587h1.469V7z"
  }));
};
var SubdirectoryArrowRight = function SubdirectoryArrowRight(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.08 2c.595 0 1.078.59 1.078 1.317V14.84h10.469l-3.784-3.578a1.037 1.037 0 0 1 0-1.526 1.19 1.19 0 0 1 1.614 0l6.54 6.183-6.54 6.185c-.223.21-.515.316-.807.316-.292 0-.585-.106-.807-.316a1.038 1.038 0 0 1 0-1.527L16.627 17H5.08a.912.912 0 0 1-.387-.086A1.081 1.081 0 0 1 4 15.92l.006-.1L4 15.684V3.317C4 2.59 4.483 2 5.08 2z"
  }));
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2022 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2022 - Finnish Meteorological Institute (FMI)
 * */

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SplitHorizontal: SplitHorizontal,
    SplitVertical: SplitVertical,
    Expand: Expand,
    UnExpand: UnExpand,
    Delete: Delete,
    DrawRegion: DrawRegion,
    DrawPolygon: DrawPolygon,
    DrawFIRLand: DrawFIRLand,
    Location: Location,
    ThumbsUp: ThumbsUp,
    Edit: Edit,
    Export: Export,
    ListItem: ListItem,
    TimeSeriesManager: TimeSeriesManager,
    Close: Close,
    KeyOption: KeyOption,
    KeyCommand: KeyCommand,
    ArrowLeft: ArrowLeft,
    ArrowRight: ArrowRight,
    ArrowDown: ArrowDown,
    ArrowUp: ArrowUp,
    Exclamation: Exclamation,
    Visibility: Visibility,
    VisibilityOff: VisibilityOff,
    HamburgerMenu: HamburgerMenu,
    GeoWebLogo: GeoWebLogo,
    Add: Add,
    Clock: Clock,
    Success: Success,
    Cancel: Cancel,
    DragHandle: DragHandle,
    AutoUpdateActive: AutoUpdateActive,
    AutoUpdateInActive: AutoUpdateInActive,
    Pause: Pause,
    Play: Play,
    Info: Info,
    TextIcon: TextIcon,
    FastForward: FastForward,
    SliderThumb: SliderThumb,
    Options: Options,
    ChevronLeft: ChevronLeft,
    ChevronRight: ChevronRight,
    ChevronUp: ChevronUp,
    ChevronDown: ChevronDown,
    Layers: Layers,
    Copy: Copy,
    Filter: Filter,
    Clear: Clear,
    Search: Search,
    Flag: Flag,
    Resize: Resize,
    PresetWorkspace: PresetWorkspace,
    Preset: Preset,
    PresetTiles: PresetTiles,
    List: List,
    Home: Home,
    Minus: Minus,
    Sort: Sort,
    Equalizer: Equalizer,
    Link: Link,
    LinkOff: LinkOff,
    Cached: Cached,
    CalendarToday: CalendarToday,
    WebAssetOff: WebAssetOff,
    Notifications: Notifications,
    Update: Update,
    SubdirectoryArrowRight: SubdirectoryArrowRight
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */
var gwButtonVariants = ['primary', 'secondary', 'tertiary', 'flat', 'tool', 'boxed'];

var defaultButtonStyle = function defaultButtonStyle(button) {
  return {
    // default styling
    color: button["default"].color,
    backgroundColor: button["default"].fill,
    textTransform: 'capitalize',
    // hover styling
    '&:hover': {
      backgroundColor: button.mouseOver.fill,
      borderColor: button.mouseOver.borderColor
    },
    // active styling
    '&.Mui-selected': {
      backgroundColor: button.active.fill,
      color: button.active.color,
      borderColor: button.active.borderColor,
      '&:hover': {
        backgroundColor: button.activeMouseOver.fill
      }
    },
    // disabled styling
    '&.Mui-disabled': {
      backgroundColor: button.disabled.fill,
      color: button.disabled.color,
      borderColor: button.disabled.borderColor
    }
  };
};
var buttonStyle = function buttonStyle(button) {
  return Object.assign(Object.assign({}, defaultButtonStyle(button)), {
    padding: '12px 8px',
    height: '40px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: button["default"].borderColor,
    borderRadius: '5px',
    // size styling
    '&[class*="sizeSmall"]': {
      fontSize: '12px',
      height: '32px',
      lineHeight: '12px'
    },
    // icon styling
    '& .MuiButton-startIcon': {
      margin: 0
    },
    '& .MuiSvgIcon-root': {
      marginRight: '8px',
      fontSize: '24px!important'
    }
  });
};
var variantsToClassName = function variantsToClassName(buttonVariants) {
  return buttonVariants.reduce(function (variants, _ref) {
    var variant = _ref.props.variant,
        style = _ref.style;
    return Object.assign(Object.assign({}, variants), _defineProperty({}, "&.".concat(variant), style));
  }, {});
};
var buttonVariants = function buttonVariants(buttons) {
  return gwButtonVariants.map(function (variant) {
    return {
      props: {
        variant: variant
      },
      style: buttonStyle(buttons[variant])
    };
  });
};

var hex2rgba = function hex2rgba(hex) {
  var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var _hex$match$map = hex.match(/\w\w/g).map(function (x) {
    return parseInt(x, 16);
  }),
      _hex$match$map2 = _slicedToArray(_hex$match$map, 3),
      r = _hex$match$map2[0],
      g = _hex$match$map2[1],
      b = _hex$match$map2[2];

  return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
};
var parseColors = function parseColors(colors) {
  return Object.keys(colors).reduce(function (segmentList, key) {
    var segment = colors[key];
    var parsedSegment = Object.keys(segment).reduce(function (list, name) {
      var value = segment[name];
      var color = value.fill || value.color; // converts hex to rgba value if color and opacity property has been set

      if (value && color && (value.opacity || value.opacity === 0)) {
        return Object.assign(Object.assign({}, list), _defineProperty({}, name, Object.assign(Object.assign({}, value), {
          rgba: hex2rgba(color, value.opacity)
        })));
      }

      return Object.assign(Object.assign({}, list), _defineProperty({}, name, value));
    }, {});
    return Object.assign(Object.assign({}, segmentList), _defineProperty({}, key, parsedSegment));
  }, {});
};
var createShadows = function createShadows(elevations) {
  var SHADOW_LIST_SIZE = 25;
  var elevationList = Object.keys(elevations).map(function (elevationName) {
    return elevations[elevationName];
  });
  return Array(SHADOW_LIST_SIZE).fill('none').map(function (value, index) {
    if (index > 0) {
      var elevationIndex = index - 1;

      if (elevationList[elevationIndex]) {
        return elevationList[elevationIndex];
      }
    }

    return value;
  });
};
var BORDER_RADIUS = 3;
var breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
  dekstopHD: 1440,
  dekstopHDWide: 1920
};
var createTheme = function createTheme(paletteType, geowebColors, shadows) {
  return createTheme$1({
    breakpoints: {
      values: {
        xs: breakpoints.mobile,
        sm: breakpoints.tablet,
        md: breakpoints.desktop,
        lg: breakpoints.dekstopHD,
        xl: breakpoints.dekstopHDWide
      }
    },
    palette: {
      mode: paletteType,
      secondary: {
        main: geowebColors.typographyAndIcons.iconLinkActive
      },
      background: {
        paper: geowebColors.background.surfaceApp,
        "default": geowebColors.background.surfaceBrowser
      },
      text: {
        primary: geowebColors.typographyAndIcons.text
      },
      // geoweb color palette
      geowebColors: geowebColors
    },
    shape: {
      borderRadius: BORDER_RADIUS
    },
    typography: {
      fontFamily: ['Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(',')
    },
    shadows: shadows,
    components: {
      MuiButton: {
        variants: buttonVariants(geowebColors.buttons)
      },
      MuiToggleButton: {
        styleOverrides: {
          root: variantsToClassName(buttonVariants(geowebColors.buttons))
        }
      },
      MuiIconButton: {
        // TODO: https://gitlab.com/opengeoweb/opengeoweb/-/issues/1926 remove default styling and create CustomIconButton
        styleOverrides: {
          root: defaultButtonStyle(geowebColors.buttons.flat)
        }
      },
      MuiCssBaseline: {
        styleOverrides: "\n          html {\n            -webkit-font-smoothing: auto;\n          }\n        "
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            minHeight: '48px!important',
            fontSize: '0.875rem',
            letterSpacing: '0.25px',
            divider: {
              borderBottomColor: geowebColors.greys.accessibleLight
            },
            li: {
              '&:hover': {
                backgroundColor: geowebColors.tab.mouseOver.rgba
              }
            },
            '&.Mui-selected': {
              background: 'none',
              boxShadow: "inset 4px 0px 0px 0px ".concat(geowebColors.typographyAndIcons.iconLinkActive)
            }
          }
        }
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: geowebColors.typographyAndIcons.iconLinkActive,
            '&.Mui-disabled': {
              color: "".concat(geowebColors.typographyAndIcons.iconLinkDisabled, "!important")
            },
            '&.Mui-checked': {
              color: geowebColors.typographyAndIcons.iconLinkActive
            }
          }
        }
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: geowebColors.typographyAndIcons.iconLinkActive,
            '&.Mui-disabled': {
              color: "".concat(geowebColors.typographyAndIcons.iconLinkDisabled, "!important")
            },
            '&.Mui-checked': {
              color: geowebColors.typographyAndIcons.iconLinkActive
            }
          }
        }
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: 'unset'
          },
          outlined: {
            borderColor: geowebColors.cards.cardContainerBorder
          }
        }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundColor: geowebColors.cards.cardContainer
          }
        }
      },
      MuiSlider: {
        styleOverrides: {
          root: {
            color: geowebColors.typographyAndIcons.iconLinkActive
          }
        }
      },
      MuiTable: {
        styleOverrides: {
          root: {
            borderSpacing: '0 0.25rem',
            borderCollapse: 'separate'
          }
        }
      },
      MuiTableRow: {
        styleOverrides: {
          head: {
            '&:hover': {
              boxShadow: shadows[0]
            }
          },
          root: {
            transition: 'box-shadow 100ms ease-out',
            boxShadow: shadows[0],
            borderRadius: BORDER_RADIUS,
            '&:hover': {
              boxShadow: shadows[1]
            },
            position: 'relative'
          }
        }
      },
      MuiTableCell: {
        styleOverrides: {
          head: {
            borderBottom: 'none',
            fontSize: '0.875rem',
            fontWeight: 400
          },
          body: {
            padding: 12,
            fontWeight: 500,
            backgroundColor: geowebColors.background.surface,
            borderStyle: 'solid',
            borderColor: 'transparent',
            borderWidth: 1,
            borderTopColor: geowebColors.cards.cardContainerBorder,
            borderBottomColor: geowebColors.cards.cardContainerBorder,
            '&:first-child': {
              borderLeftColor: geowebColors.cards.cardContainerBorder,
              borderRadius: "".concat(BORDER_RADIUS, "px 0px 0px ").concat(BORDER_RADIUS, "px")
            },
            '&:last-child': {
              borderRightColor: geowebColors.cards.cardContainerBorder,
              borderRadius: "0px ".concat(BORDER_RADIUS, "px ").concat(BORDER_RADIUS, "px 0px")
            }
          }
        }
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            position: 'relative',
            '&:after': {
              content: '""',
              position: 'absolute',
              bottom: 0,
              height: 1,
              width: '100%',
              zIndex: 0,
              backgroundColor: hex2rgba(geowebColors.greys.accessible, 0.2)
            }
          },
          indicator: {
            zIndex: 1,
            backgroundColor: geowebColors.typographyAndIcons.iconLinkActive
          }
        }
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: 'initial',
            '&.Mui-selected': {
              color: geowebColors.typographyAndIcons.iconLinkActive
            },
            '&:hover': {
              opacity: 1,
              color: geowebColors.typographyAndIcons.iconLinkActive,
              backgroundColor: geowebColors.tab.mouseOver.rgba
            }
          }
        }
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            color: geowebColors.typographyAndIcons.text,
            fontSize: '14px',
            minHeight: '36px'
          },
          divider: {
            borderBottomColor: hex2rgba(geowebColors.greys.accessible, 0.2)
          }
        }
      },
      MuiListItemIcon: {
        styleOverrides: {
          root: {
            color: geowebColors.typographyAndIcons.icon,
            width: '24px',
            height: '24px'
          }
        }
      },
      MuiBackdrop: {
        styleOverrides: {
          root: {
            backgroundColor: geowebColors.backdrops.black.rgba
          }
        }
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: geowebColors.tooltips.tooltipContainer.rgba,
            color: geowebColors.tooltips.tooltipText.color,
            padding: '8px 12px',
            fontSize: 16,
            fontWeight: 400,
            fontStretch: 'normal',
            fontStyle: 'normal',
            letterSpacing: 0.44,
            lineHeight: 1.56
          }
        }
      },
      MuiLink: {
        styleOverrides: {
          root: {
            color: geowebColors.typographyAndIcons.textLinkActive,
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
              textDecorationColor: geowebColors.typographyAndIcons.textLinkActive
            }
          }
        }
      },
      MuiAlert: {
        styleOverrides: {
          standardError: {
            border: geowebColors.functional.errorOutline.border,
            borderRadius: '0px',
            backgroundColor: geowebColors.functional.errorOutline.fill,
            '& .MuiAlert-icon': {
              color: geowebColors.functional.error,
              opacity: 1
            }
          },
          standardWarning: {
            border: geowebColors.functional.warningOutline.border,
            borderRadius: '0px',
            backgroundColor: geowebColors.functional.warningOutline.fill,
            '& .MuiAlert-icon': {
              color: geowebColors.functional.warning,
              opacity: 1
            }
          },
          standardInfo: {
            border: geowebColors.functional.notificationOutline.border,
            borderRadius: '0px',
            backgroundColor: geowebColors.functional.notificationOutline.fill,
            '& .MuiAlert-icon': {
              color: geowebColors.functional.notification,
              opacity: 1
            }
          },
          standardSuccess: {
            border: geowebColors.functional.successOutline.border,
            borderRadius: '0px',
            backgroundColor: geowebColors.functional.successOutline.fill,
            '& .MuiAlert-icon': {
              color: geowebColors.functional.success,
              opacity: 1
            }
          },
          action: {
            color: geowebColors.buttons.tertiary["default"].color
          },
          message: {
            fontSize: '14px',
            lineHeight: 1.43,
            letterSpacing: '0.25px',
            color: geowebColors.typographyAndIcons.text
          }
        }
      },
      MuiTextField: {
        defaultProps: {
          variant: 'filled'
        }
      },
      MuiFilledInput: {
        styleOverrides: {
          root: {
            backgroundColor: geowebColors.textInputField["default"].rgba,
            '&.Mui-focused': {
              backgroundColor: geowebColors.textInputField.active.rgba,
              '&:after': {
                borderColor: 'transparent'
              }
            },
            '&.Mui-disabled': {
              backgroundColor: geowebColors.textInputField.disabled.rgba
            },
            '&.Mui-error': {
              '&:after': {
                borderColor: geowebColors.captions.captionError.color
              }
            }
          },
          underline: {
            '&:after': {
              borderWidth: '1px'
            },
            '&.Mui-disabled:before': {
              borderBottomStyle: 'solid'
            }
          }
        }
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            color: geowebColors.captions.captionStatus.color,
            opacity: geowebColors.captions.captionStatus.opacity,
            '&.Mui-focused': {
              color: geowebColors.captions.captionInformation.color,
              opacity: geowebColors.captions.captionInformation.opacity
            },
            '&.Mui-error': {
              color: geowebColors.captions.captionError.color,
              opacity: geowebColors.captions.captionError.opacity
            },
            '&.Mui-disabled': {
              color: geowebColors.captions.captionDisabled.color,
              opacity: geowebColors.captions.captionDisabled.opacity
            }
          }
        }
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            color: geowebColors.captions.captionStatus.color,
            opacity: geowebColors.captions.captionStatus.opacity,
            '&.Mui-error': {
              color: geowebColors.captions.captionError.color,
              opacity: geowebColors.captions.captionError.opacity
            },
            '&.Mui-disabled': {
              color: geowebColors.captions.captionDisabled.color,
              opacity: geowebColors.captions.captionDisabled.opacity
            }
          }
        }
      },
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            color: geowebColors.customSwitch.thumb,
            '&.Mui-checked': {
              color: geowebColors.customSwitch.thumb
            },
            '&.Mui-disabled': {
              color: geowebColors.customSwitch.thumbDisabled
            },
            '&.Mui-checked.Mui-disabled': {
              color: geowebColors.customSwitch.thumbDisabled
            },
            '&.Mui-checked+.MuiSwitch-track': {
              backgroundColor: geowebColors.customSwitch.trackActive
            },
            '&.Mui-disabled+.MuiSwitch-track': {
              backgroundColor: geowebColors.customSwitch.track
            },
            '&.Mui-checked.Mui-disabled+.MuiSwitch-track': {
              backgroundColor: geowebColors.customSwitch.trackActive
            }
          },
          track: {
            backgroundColor: geowebColors.customSwitch.track,
            opacity: '1 !important'
          }
        }
      }
    }
  });
};

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var colors$1 = {
  background: {
    surface: '#FFFFFF',
    surfaceApp: '#F5F5F5',
    surfaceBrowser: '#CFCFCF'
  },
  brand: {
    brand: '#00547d'
  },
  buttons: {
    primary: {
      "default": {
        fill: '#186DFF',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      mouseOver: {
        fill: '#1047B0',
        color: '#FFFFFF',
        borderColor: '#71A6FF'
      },
      active: {
        fill: '#186DFF',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      activeMouseOver: {},
      disabled: {
        fill: 'transparent',
        color: '#707070',
        borderColor: 'transparent'
      }
    },
    secondary: {
      "default": {
        fill: '#0876b6',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      mouseOver: {
        fill: '#064c84',
        color: '#FFFFFF',
        borderColor: '#3DA6FF'
      },
      active: {
        fill: '#0876b6',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      activeMouseOver: {},
      disabled: {
        fill: 'transparent',
        color: '#707070',
        borderColor: 'transparent'
      }
    },
    tertiary: {
      "default": {
        fill: 'transparent',
        color: '#575F7A',
        borderColor: '#575F7A'
      },
      mouseOver: {
        fill: '#E3E4E7',
        color: '#575F7A',
        borderColor: '#575F7A'
      },
      active: {
        fill: 'transparent',
        color: '#186DFF',
        borderColor: '#186DFF'
      },
      activeMouseOver: {
        fill: 'rgba(24, 109, 255, 0.1)',
        color: '#186DFF',
        borderColor: '#186DFF'
      },
      disabled: {
        fill: 'transparent',
        color: '#707070',
        borderColor: 'transparent'
      }
    },
    flat: {
      "default": {
        fill: 'transparent',
        color: '#575F7A',
        borderColor: 'transparent'
      },
      mouseOver: {
        fill: '#E3E4E7',
        color: '#575F7A',
        borderColor: 'transparent'
      },
      active: {
        fill: 'transparent',
        color: '#186DFF',
        borderColor: 'transparent'
      },
      activeMouseOver: {
        fill: 'rgba(24, 109, 255, 0.1)',
        color: '#186DFF',
        borderColor: 'transparent'
      },
      disabled: {
        fill: 'transparent',
        color: '#707070',
        borderColor: 'transparent'
      }
    },
    tool: {
      "default": {
        fill: '#ECEDEE',
        color: '#575F7A',
        borderColor: 'transparent'
      },
      mouseOver: {
        fill: '#E3E4E7',
        color: '#575F7A',
        borderColor: 'transparent'
      },
      active: {
        fill: '#186DFF',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      activeMouseOver: {
        fill: '#1047B0',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      disabled: {
        fill: 'transparent',
        color: '#707070',
        borderColor: 'transparent'
      }
    },
    boxed: {
      "default": {
        fill: 'transparent',
        color: '#575F7A',
        borderColor: '#575f7a'
      },
      mouseOver: {
        fill: '#E3E4E7',
        color: '#575F7A',
        borderColor: '#575f7a'
      },
      active: {
        fill: '#186DFF',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      activeMouseOver: {
        fill: '#1047B0',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      disabled: {
        fill: 'transparent',
        color: '#707070',
        borderColor: 'transparent'
      }
    },
    focusDefault: {
      outline: 'solid 2px #419cfe'
    }
  },
  typographyAndIcons: {
    text: '#051039',
    icon: '#051039',
    buttonIcon: '#FFFFFF',
    iconLinkActive: '#186DFF',
    iconLinkDisabled: '#CCCCCC',
    textLinkActive: '#186DFF',
    buttonIconTertiaryFlat: '#575F7A',
    inactiveText: '#707070'
  },
  textInputField: {
    "default": {
      fill: '#051039',
      opacity: 0.07
    },
    active: {
      fill: '#051039',
      opacity: 0.02
    },
    disabled: {
      fill: '#000000',
      opacity: 0
    }
  },
  tab: {
    mouseOver: {
      fill: '#051039',
      opacity: 0.07
    }
  },
  greys: {
    accessible: '#767676',
    accessibleLight: '#C5C5C5'
  },
  cards: {
    cardContainer: '#FFFFFF',
    cardContainerBorder: '#EEEEEE'
  },
  backdrops: {
    black: {
      fill: '#000000',
      opacity: 0.5
    },
    white: {
      fill: '#FFFFFF',
      opacity: 0.24
    }
  },
  screenManager: {
    activeWindow: '#FFFFFF',
    inactiveWindow: '#E8E5E5'
  },
  timeSlider: {
    // player
    playerNeedleTimeTop: {
      fill: '#E3004F',
      opacity: 100
    },
    playerNeedleTime: {
      fill: '#FFD523',
      opacity: 0.75
    },
    playerNeedlePlayerTop: {
      fill: '#051039',
      opacity: 100
    },
    playerNeedlePlayer: {
      fill: '#67F0FF',
      opacity: 0.75
    },
    playerRailObservation: {
      fill: '#0876B6',
      opacity: 100
    },
    playerRailSelection: {
      fill: '#C6D111',
      opacity: 0.5
    },
    playerRailForecastData: {
      fill: '#FD64FF',
      opacity: 0.6
    },
    playerRailForecastNoData: {
      fill: '#051039',
      opacity: 0.67
    },
    playerTimeMarkers: {
      fill: '#2C2C2C'
    },
    playerTimeText: {
      color: '#FFFFFF',
      fontFamily: 'Roboto',
      fontSize: 14
    },
    // timeline
    timelineIndicator: {
      fill: '#767676'
    },
    timelineText: {
      fontSize: 14,
      color: '#051039',
      fontFamily: 'Roboto'
    },
    timelineTimeScale: {
      fill: '#979797'
    },
    timelineNightTime: {
      fill: '#070808',
      opacity: 0.1
    },
    timelineTimelineSurface: {
      fill: '#FFFFFF'
    },
    timelineMonthChangeDash: {
      fill: '#767676',
      opacity: 0.5
    },
    timelineSelectionBackground: {
      fill: '#11D1C6',
      opacity: 0.25
    },
    // time scale
    timeScaleText: {
      fontSize: 12
    },
    timeScalePointer: {
      fill: '#F8F9F9'
    },
    timeScaleHorizontalScale: {
      fill: '#070808',
      opacity: 0.2
    },
    timeScaleTimeIndicators: {
      fill: '#767676'
    },
    timeScaleTimeIndicatorsActive: {
      fill: '#051039'
    },
    timeScaleShadowButtonScale: {
      filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.28)) drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.24)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.40))'
    }
  },
  customSlider: {
    rail: '#488BFD',
    railDisabled: '#CCCCCC',
    track: '#186DFF',
    trackDisabled: '#CCCCCC',
    thumb: '#F8F9F9',
    thumbDisabled: '#CCCCCC',
    mark: '#FFFFFF',
    markDisabled: '#FFFFFF'
  },
  customSwitch: {
    thumb: '#F8F9F9',
    thumbDisabled: '#F5F5F5',
    track: '#707070',
    trackActive: '#186DFF'
  },
  syncGroups: {
    drawerOpen: {
      fill: '#E8E5E5'
    }
  },
  layerManager: {
    tableRowDefaultText: {
      color: '#051039',
      opacity: 0.87,
      fontSize: 12
    },
    tableRowDefaultCardContainer: {
      fill: '#FFFFFF',
      border: '1px solid #EEEEEE'
    },
    tableRowDisabledText: {
      color: '#767676',
      opacity: 0.87,
      fontSize: 12
    },
    tableRowDisabledCardContainer: {
      fill: '#F5F5F5',
      border: '1px solid #EEEEEE'
    }
  },
  tooltips: {
    tooltipContainer: {
      fill: '#232323',
      opacity: 1
    },
    tooltipText: {
      color: '#FFFFFF'
    }
  },
  captions: {
    captionStatus: {
      color: '#051039',
      opacity: 0.67
    },
    captionInformation: {
      color: '#1100FF',
      opacity: 1
    },
    captionError: {
      color: '#C00000',
      opacity: 1
    },
    captionDisabled: {
      color: '#707070',
      opacity: 1
    }
  },
  functional: {
    success: '#72BB23',
    successOutline: {
      fill: '#FCFFEB',
      border: ' 1px solid #72BB23'
    },
    error: '#C00000',
    errorOutline: {
      fill: '#F9E8EA',
      border: '1px solid #C00000'
    },
    warning: '#FFA800',
    warningOutline: {
      fill: '#FFF8EB',
      border: '1px solid #FFA800'
    },
    warningHighlight: {
      fill: '#FFA800',
      opacity: 0.2
    },
    notification: '#0062E6',
    notificationOutline: {
      fill: '#DFF2FD',
      border: '1px solid #0062E6'
    }
  }
}; // https://app.zeplin.io/project/5ecf84a3c6ae1047a368f393/screen/609bb6a5287bd1abe0de39a7

var elevations$1 = {
  elevation_01: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 0 2px 0 rgba(0, 0, 0, 0.14)',
  elevation_02: '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.14)',
  elevation_03: '0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.12), 0 3px 3px 0 rgba(0, 0, 0, 0.14)',
  elevation_04: '0 1px 10px 0 rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.14)',
  elevation_06: '0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14)',
  elevation_08: '0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)',
  elevation_09: '0 5px 6px 0 rgba(0, 0, 0, 0.2), 0 3px 16px 2px rgba(0, 0, 0, 0.12), 0 9px 12px 1px rgba(0, 0, 0, 0.14)',
  elevation_12: '0 7px 8px 0 rgba(0, 0, 0, 0.2), 0 5px 22px 4px rgba(0, 0, 0, 0.12), 0 12px 17px 2px rgba(0, 0, 0, 0.14)',
  elevation_16: '0 8px 10px 0 rgba(0, 0, 0, 0.2), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.14)',
  elevation_24: '0 11px 15px 0 rgba(0, 0, 0, 0.2), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 24px 38px 3px rgba(0, 0, 0, 0.14)'
};
var lightTheme = createTheme('light', parseColors(colors$1), createShadows(elevations$1));

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var geowebColors = Object.assign({}, colors$1);
var GWTheme = createTheme$1({
  palette: {
    secondary: {
      main: '#0075a9'
    },
    action: {
      active: '#ffa800'
    },
    text: {
      disabled: '#051039'
    },
    geowebColors: parseColors(geowebColors)
  },
  shape: {
    borderRadius: 3
  },
  typography: {
    h6: {
      fontSize: '16px'
    },
    subtitle1: {
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: 1.5,
      letterSpacing: '0.15px',
      opacity: 0.87,
      color: '#051039'
    },
    subtitle2: {
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 1.71,
      letterSpacing: '0.1px',
      opacity: 0.87,
      color: '#051039'
    },
    body1: {
      fontSize: '16px',
      lineHeight: 1.56,
      letterSpacing: '0.44px',
      color: '#051039'
    },
    body2: {
      fontSize: '14px',
      lineHeight: 1.43,
      letterSpacing: '0.25px',
      color: '#051039'
    },
    overline: {
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: 1.43,
      letterSpacing: '0.25px',
      color: '#051039',
      opacity: 0.7
    },
    caption: {
      fontSize: '12px',
      lineHeight: 1.33,
      letterSpacing: '0.4px',
      color: '#051039',
      opacity: 0.7
    },
    button: {
      fontWeight: 500,
      fontSize: '14px',
      color: '0075a9'
    }
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: '2px',
          fontSize: '16px',
          fontWeight: 'normal',
          padding: '10px',
          backgroundColor: '#232323'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: '#0075a9'
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: '#CCCCCC!important'
          },
          '&.Mui-checked': {
            color: '#0075a9'
          }
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: '#0075a9'
        },
        select: {
          '&:focus': {
            backgroundColor: 'rgba(0, 117, 169, 0.05)'
          }
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        standardError: {
          border: '1px solid #c00000',
          borderRadius: '0px',
          backgroundColor: '#fff0ea'
        },
        standardWarning: {
          border: '1px solid #ffa800',
          borderRadius: '0px',
          backgroundColor: '#fff8eb'
        },
        standardInfo: {
          border: '1px solid #0062e6',
          borderRadius: '0px',
          backgroundColor: '#eaf3ff'
        },
        standardSuccess: {
          border: '1px solid #72bb23',
          borderRadius: '0px',
          backgroundColor: '#fcffeb'
        },
        action: {
          color: '#0075a9'
        },
        message: {
          fontSize: '14px',
          lineHeight: 1.43,
          letterSpacing: '0.25px',
          color: '#051039'
        }
      }
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          minHeight: '30px'
        },
        scrollButtons: {
          width: '20px'
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: '30px',
          textTransform: 'none',
          minWidth: '76px',
          '@media (min-width: 600px)': {
            minWidth: '76px'
          }
        },
        labelIcon: {
          minHeight: '30px'
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          '&$selected': {
            backgroundColor: 'rgba(0, 117, 169, 0.15)',
            borderLeft: '4px solid #0075a9',
            '&:hover': {
              backgroundColor: 'rgba(0, 117, 169, 0.10)'
            }
          }
        },
        button: {
          '&:hover': {
            backgroundColor: 'rgba(0, 117, 169, 0.15)'
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: 'rgba(0, 117, 169, 0.15)',
            borderLeft: '4px solid #0075a9',
            '&:hover': {
              backgroundColor: 'rgba(0, 117, 169, 0.10)'
            }
          },
          '&:hover': {
            backgroundColor: 'rgba(0, 117, 169, 0.15)'
          }
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(5, 16, 57, 0.7)',
          '&.Mui-focused': {
            color: '#0075a9'
          },
          '&.Mui-error': {
            color: '#d32f2f!important'
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&$focused $notchedOutline': {
            borderColor: '#0075a9'
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(0, 117, 169, 0.05)',
          color: '#051039',
          '&.Mui-disabled': {
            backgroundColor: 'white'
          },
          '&.Mui-focused': {
            backgroundColor: 'rgba(0,0,0,0.09)'
          }
        },
        underline: {
          '&.Mui-disabled:before': {
            borderBottomStyle: 'none'
          }
        }
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: '#CCCCCC!important'
          },
          '&.Mui-checked': {
            color: '#0075a9'
          }
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          '&:last-child': {
            paddingBottom: 0
          }
        }
      }
    },
    MuiDialog: {
      styleOverrides: {
        paperWidthLg: {
          maxWidth: '1280px'
        }
      }
    },
    MuiButton: {
      variants: buttonVariants(geowebColors.buttons)
    },
    MuiToggleButton: {
      styleOverrides: {
        root: variantsToClassName(buttonVariants(geowebColors.buttons))
      }
    }
  }
});

/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2021 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2021 - Finnish Meteorological Institute (FMI)
 * */

var colors = {
  background: {
    surface: '#303030',
    surfaceApp: '#2B2B2B',
    surfaceBrowser: '#181818'
  },
  brand: {
    brand: '#404040'
  },
  buttons: {
    primary: {
      "default": {
        fill: '#186DFF',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      mouseOver: {
        fill: '#1047B0',
        color: '#FFFFFF',
        borderColor: '#71A6FF'
      },
      active: {
        fill: '#186DFF',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      activeMouseOver: {},
      disabled: {
        fill: 'transparent',
        color: '#B0B0B0',
        borderColor: 'transparent'
      }
    },
    secondary: {
      "default": {
        fill: '#0876b6',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      mouseOver: {
        fill: '#064C84',
        color: '#FFFFFF',
        borderColor: '#3DA6FF'
      },
      active: {
        fill: '#0876B6',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      activeMouseOver: {},
      disabled: {
        fill: 'transparent',
        color: '#707070',
        borderColor: 'transparent'
      }
    },
    tertiary: {
      "default": {
        fill: 'transparent',
        color: '#E5E5E5',
        borderColor: '#E5E5E5'
      },
      mouseOver: {
        fill: '#494949',
        color: '#E5E5E5',
        borderColor: '#E5E5E5'
      },
      active: {
        fill: 'transparent',
        color: '#488BFD',
        borderColor: '#48A8FA'
      },
      activeMouseOver: {
        fill: 'rgba(24, 109, 255, 0.1)',
        color: '#488BFD',
        borderColor: '#488BFD'
      },
      disabled: {
        fill: 'transparent',
        color: '#B0B0B0',
        borderColor: 'transparent'
      }
    },
    flat: {
      "default": {
        fill: 'transparent',
        color: '#E5E5E5',
        borderColor: 'transparent'
      },
      mouseOver: {
        fill: '#494949',
        color: '#E5E5E5',
        borderColor: 'transparent'
      },
      active: {
        fill: 'transparent',
        color: '#488BFD',
        borderColor: 'transparent'
      },
      activeMouseOver: {
        fill: 'rgba(24, 109, 255, 0.1)',
        color: '#488BFD',
        borderColor: 'transparent'
      },
      disabled: {
        fill: 'transparent',
        color: '#B0B0B0',
        borderColor: 'transparent'
      }
    },
    tool: {
      "default": {
        fill: '#393939',
        color: '#E5E5E5',
        borderColor: 'transparent'
      },
      mouseOver: {
        fill: '#494949',
        color: '#E5E5E5',
        borderColor: 'transparent'
      },
      active: {
        fill: '#186DFF',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      activeMouseOver: {
        fill: '#1047B0',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      disabled: {
        fill: 'transparent',
        color: '#B0B0B0',
        borderColor: 'transparent'
      }
    },
    boxed: {
      "default": {
        fill: 'transparent',
        color: '#E5E5E5',
        borderColor: '#e5e5e5'
      },
      mouseOver: {
        fill: '#494949',
        color: '#E5E5E5',
        borderColor: '#e5e5e5'
      },
      active: {
        fill: '#186DFF',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      activeMouseOver: {
        fill: '#1047B0',
        color: '#FFFFFF',
        borderColor: 'transparent'
      },
      disabled: {
        fill: 'transparent',
        color: '#B0B0B0',
        borderColor: 'transparent'
      }
    },
    focusDefault: {
      outline: 'solid 2px #419cfe'
    }
  },
  typographyAndIcons: {
    text: '#FFFFFF',
    icon: '#FFFFFF',
    buttonIcon: '#FFFFFF',
    iconLinkActive: '#488BFD',
    iconLinkDisabled: '#5E5E5E',
    textLinkActive: '#488BFD',
    buttonIconTertiaryFlat: '#C5C5C5',
    inactiveText: '#B0B0B0'
  },
  textInputField: {
    "default": {
      fill: '#000000',
      opacity: 0.15
    },
    active: {
      fill: '#909090',
      opacity: 0.2
    },
    disabled: {
      color: '#000000',
      opacity: 0
    }
  },
  tab: {
    mouseOver: {
      fill: '#000000',
      opacity: 0.17
    }
  },
  greys: {
    accessible: '#A2A2A2',
    accessibleLight: '#6F6F6F'
  },
  cards: {
    cardContainer: '#303030',
    cardContainerBorder: '#404040'
  },
  backdrops: {
    black: {
      fill: '#000000',
      opacity: 0.5
    },
    white: {
      fill: '#FFFFFF',
      opacity: 0.24
    }
  },
  screenManager: {
    activeWindow: '#242424',
    inactiveWindow: '#303030'
  },
  timeSlider: {
    // player
    playerNeedleTimeTop: {
      fill: '#E3004F',
      opacity: 100
    },
    playerNeedleTime: {
      fill: '#FFD523',
      opacity: 0.75
    },
    playerNeedlePlayerTop: {
      fill: '#051039',
      opacity: 100
    },
    playerNeedlePlayer: {
      fill: '#67F0FF',
      opacity: 0.75
    },
    playerRailObservation: {
      fill: '#0876B6',
      opacity: 100
    },
    playerRailSelection: {
      fill: '#C6D111',
      opacity: 0.5
    },
    playerRailForecastData: {
      fill: '#FD64FF',
      opacity: 0.6
    },
    playerRailForecastNoData: {
      fill: '#051039',
      opacity: 0.67
    },
    playerTimeMarkers: {
      fill: '#2C2C2C'
    },
    playerTimeText: {
      color: '#FFFFFF',
      fontFamily: 'Roboto',
      fontSize: 14
    },
    // timeline
    timelineIndicator: {
      fill: '#A2A2A2'
    },
    timelineText: {
      fontSize: 14,
      color: '#FFFFFF',
      fontFamily: 'Roboto'
    },
    timelineTimeScale: {
      fill: '#979797'
    },
    timelineNightTime: {
      fill: '#070808',
      opacity: 0.3
    },
    timelineTimelineSurface: {
      fill: '#303030'
    },
    timelineMonthChangeDash: {
      fill: '#A2A2A2',
      opacity: 0.5
    },
    timelineSelectionBackground: {
      fill: '#11D1C6',
      opacity: 0.25
    },
    // time scale
    timeScaleText: {
      fontSize: 12
    },
    timeScalePointer: {
      fill: '#F8F9F9'
    },
    timeScaleHorizontalScale: {
      fill: '#000000',
      opacity: 0.8
    },
    timeScaleTimeIndicators: {
      fill: '#A2A2A2'
    },
    timeScaleTimeIndicatorsActive: {
      fill: '#FFFFFF'
    },
    timeScaleShadowButtonScale: {
      filter: 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.28)) drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.24)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.40))'
    }
  },
  customSlider: {
    rail: '#488BFD',
    railDisabled: '#5E5E5E',
    track: '#186DFF',
    trackDisabled: '#5E5E5E',
    thumb: '#F8F9F9',
    thumbDisabled: '#5E5E5E',
    mark: '#FFFFFF',
    markDisabled: '#303030'
  },
  customSwitch: {
    thumb: '#F8F9F9',
    thumbDisabled: '#F5F5F5',
    track: '#BDBDBD',
    trackActive: '#488BFD'
  },
  syncGroups: {
    drawerOpen: {
      fill: '#232323'
    }
  },
  layerManager: {
    tableRowDefaultText: {
      color: '#FFFFFF',
      opacity: 0.87,
      fontSize: 12
    },
    tableRowDefaultCardContainer: {
      fill: '#303030',
      border: '1px solid #404040'
    },
    tableRowDisabledText: {
      color: '#909090',
      opacity: 0.87,
      fontSize: 12
    },
    tableRowDisabledCardContainer: {
      fill: '#2B2B2B',
      border: '1px solid #404040'
    }
  },
  tooltips: {
    tooltipContainer: {
      fill: '#232323',
      opacity: 1
    },
    tooltipText: {
      color: '#FFFFFF'
    }
  },
  captions: {
    captionStatus: {
      color: '#FFFFFF',
      opacity: 0.7
    },
    captionInformation: {
      color: '#9EC2FF',
      opacity: 1
    },
    captionError: {
      color: '#FF8F8F',
      opacity: 1
    },
    captionDisabled: {
      color: '#B0B0B0',
      opacity: 1
    }
  },
  functional: {
    success: '#72BB23',
    successOutline: {
      fill: 'rgba(114, 187, 35, 0.25)',
      border: ' 1px solid #72BB23'
    },
    error: '#C00000',
    errorOutline: {
      fill: 'rgba(192, 0, 0, 0.25)',
      border: '1px solid #C00000'
    },
    warning: '#FFA800',
    warningOutline: {
      fill: 'rgba(255, 168, 0, 0.25)',
      border: '1px solid #FFA800'
    },
    warningHighlight: {
      fill: '#FFA800',
      opacity: 0.2
    },
    notification: '#186DFF',
    notificationOutline: {
      fill: 'rgba(24, 109, 255, 0.25)',
      border: '1px solid #186DFF'
    }
  }
}; // https://app.zeplin.io/project/5ecf84a3c6ae1047a368f393/screen/6093e694124ecf3886de76d4

var elevations = {
  elevation_01: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.12), 0 0 2px 0 rgba(0, 0, 0, 0.14)',
  elevation_02: '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.14)',
  elevation_03: '0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 4px 0 rgba(0, 0, 0, 0.12), 0 3px 3px 0 rgba(0, 0, 0, 0.14)',
  elevation_04: '0 1px 10px 0 rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.14)',
  elevation_06: '0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14)',
  elevation_08: '0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)',
  elevation_09: '0 5px 6px 0 rgba(0, 0, 0, 0.2), 0 3px 16px 2px rgba(0, 0, 0, 0.12), 0 9px 12px 1px rgba(0, 0, 0, 0.14)',
  elevation_12: '0 7px 8px 0 rgba(0, 0, 0, 0.2), 0 5px 22px 4px rgba(0, 0, 0, 0.12), 0 12px 17px 2px rgba(0, 0, 0, 0.14)',
  elevation_16: '0 8px 10px 0 rgba(0, 0, 0, 0.2), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.14)',
  elevation_24: '0 11px 15px 0 rgba(0, 0, 0, 0.2), 0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 24px 38px 3px rgba(0, 0, 0, 0.14)'
};
var darkTheme = createTheme('dark', parseColors(colors), createShadows(elevations));

var ThemeContext = /*#__PURE__*/React.createContext({
  toggleTheme: null,
  isDark: null
});
var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      defaultTheme = _ref$theme === void 0 ? lightTheme : _ref$theme,
      _ref$disableCssBaseli = _ref.disableCssBaseline,
      disableCssBaseline = _ref$disableCssBaseli === void 0 ? false : _ref$disableCssBaseli;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isDark = _React$useState2[0],
      setDark = _React$useState2[1];

  var currentTheme = React.useMemo(function () {
    return isDark ? darkTheme : defaultTheme;
  }, [isDark, defaultTheme]);

  var toggleTheme = function toggleTheme() {
    return setDark(!isDark);
  };

  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: {
      toggleTheme: toggleTheme,
      isDark: isDark
    }
  }, /*#__PURE__*/React.createElement(ThemeProvider$1, {
    theme: currentTheme
  }, !disableCssBaseline && /*#__PURE__*/React.createElement(CssBaseline, null), children));
};
var useThemeContext = function useThemeContext() {
  return React.useContext(ThemeContext);
}; // Wrapper for storybook stories. Will include later an additional wrapper after upgrade to MUI5

var ThemeWrapper = function ThemeWrapper(_ref2) {
  var children = _ref2.children,
      _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? lightTheme : _ref2$theme,
      _ref2$disableCssBasel = _ref2.disableCssBaseline,
      disableCssBaseline = _ref2$disableCssBasel === void 0 ? false : _ref2$disableCssBasel;
  return /*#__PURE__*/React.createElement(StyledEngineProvider, {
    injectFirst: true
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme,
    disableCssBaseline: disableCssBaseline
  }, children));
}; // Wrapper for storybook stories with GWTheme. Will be deprecated

var ThemeWrapperOldTheme = function ThemeWrapperOldTheme(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return /*#__PURE__*/React.createElement(ThemeWrapper, Object.assign({
    theme: GWTheme,
    disableCssBaseline: true
  }, props), children);
};

export { Add, ArrowDown, ArrowLeft, ArrowRight, ArrowUp, AutoUpdateActive, AutoUpdateInActive, Cached, CalendarToday, Cancel, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Clear, Clock, Close, Copy, Delete, DragHandle, DrawFIRLand, DrawPolygon, DrawRegion, Edit, Equalizer, Exclamation, Expand, Export, FastForward, Filter, Flag, GWTheme, GeoWebLogo, HamburgerMenu, Home, index as Icons, Info, KeyCommand, KeyOption, Layers, Link, LinkOff, List, ListItem, Location, Minus, Notifications, Options, Pause, Play, Preset, PresetTiles, PresetWorkspace, Resize, Search, SliderThumb, Sort, SplitHorizontal, SplitVertical, SubdirectoryArrowRight, Success, TextIcon, ThemeContext, ThemeProvider, ThemeWrapper, ThemeWrapperOldTheme, ThumbsUp, TimeSeriesManager, UnExpand, Update, Visibility, VisibilityOff, WebAssetOff, darkTheme, gwButtonVariants, lightTheme, useThemeContext };
